{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "ألسنة تحديد لغة النموذج"
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "ليس لديك الصلاحيات الكافية للوصول إلى هذه الصفحة."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "تقويم",
    "URL_WITH_EVENT": "{description}\n انضم إلى حدث الويب: {url}"
  },
  "ANONYMOUS": "مجهول",
  "API_SAUCE": {
    "CANCEL_ERROR": "تم إيقاف طلب الخادم.",
    "CLIENT_ERROR": "آه، حدث خطأ غير متوقع.",
    "CONNECTION_ERROR": "الخادم غير متاح.",
    "NETWORK_ERROR": "خطأ في الشبكة، يرجى التحقق من الاتصال الخاص بك.",
    "SERVER_ERROR": "آه، حدث خطأ غير متوقع.",
    "TIMEOUT_ERROR": "الخادم لم يرد في الوقت المناسب."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "غير منشورة",
    "PUBLICATION_ALERT": "تمت جدولته في {date} في {time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "صورة المالك",
    "TITLE": "صاحب"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "اختر مسؤولاً",
    "TITLE": "قم بتعيين هذه المساهمة"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "لا يمكن حذف المرفق.",
      "TITLE": "خطأ -"
    }
  },
  "ATTENDANCE": {
    "ATTEND": "يسجل",
    "ATTENDING": "مسجل"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "أوافق على سياسة خصوصية {spaceName} <terms> </terms>.",
    "ACCEPT_SPACE_TERMS": "أوافق على شروط استخدام <privacy> </privacy> الخاصة بـ {spaceName}.",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "أوافق على سياسة خصوصية {spaceName} <privacy> </privacy> و <terms> شروط الاستخدام </terms>.",
    "ACCEPT_TERMS_AND_PRIVACY": "أوافق على {terms} و {privacy} الخاصة بـ Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "تسجيل الدخول باستخدام {provider}",
    "AUTH_LIST_TITLE": "خدمات المصادقة الخارجية",
    "BACKGROUND_ALT": "خلفية تسجيل الدخول",
    "CONTINUE_WITHOUT_SIGNUP": "المتابعة بدون حساب",
    "DELETE_TOAST": "تم تسجيل الخروج بنجاح من خدمة المصادقة الخارجية.",
    "DESCRIPTION": "سيسمح لك تسجيلك في Fluicity Engage بالمشاركة في المشاورات حول {spaceName} وسيمنحك الوصول إلى الاستشارات الأخرى المنظمة حول Fluicity Engage. لمعرفة المزيد حول كيفية إدارتنا لمعلوماتك الشخصية وممارسة حقوقك ، يرجى زيارة <b>سياسة الخصوصية</b> الخاصة بنا",
    "EMAIL_PLACEHOLDER": "example@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "من خلال الانضمام إلى <strong>{spaceName}</strong> ، سيتم إخطارك بآخر الاستشارات والأخبار.<br></br><br></br> يمكنك أيضًا المساعدة في فهم ما إذا كان النشاط يمثل سكان العالم بشكل أفضل من خلال مشاركة بعض المعلومات:",
      "TITLE": "انضم إلى {spaceName}!"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "قم بتكوين كلمة مرور لحذف خدمة المصادقة الخارجية هذه.",
      "DELETE_AUTH_FAILED": "لا يمكن حذف خدمة المصادقة الخارجية.",
      "INVALID_EMAIL": "تنسيق عنوان البريد الإلكتروني الخاص بك غير صالح.",
      "NO_ASSOCIATED_ACCOUNT": "لا يوجد حساب مرتبط.",
      "REQUIRED_CHECKBOX": "يجب عليك تحديد هذا المربع.",
      "REQUIRED_EMAIL": "يجب عليك إدخال عنوان البريد الإلكتروني.",
      "REQUIRED_FIRST_NAME": "يجب عليك إدخال الاسم الأول.",
      "REQUIRED_LAST_NAME": "يجب عليك إدخال اسم العائلة.",
      "REQUIRED_PASSWORD": "يجب عليك إدخال كلمة المرور.",
      "SHORT_PASSWORD": "يجب أن تتكون كلمة المرور من {count} من الأحرف على الأقل."
    },
    "FACEBOOK_LOAD_ERROR": "يبدو أن امتدادًا في متصفحك يمنعنا من استخدام مصادقة Facebook. يرجى تعطيل الامتداد إذا كنت ترغب في استخدام هذه الميزة.",
    "FIRST_NAME_PLACEHOLDER": "مثال: Ahmed",
    "FORGOT_PASSWORD": "هل نسيت كلمة المرور؟",
    "HAS_ACCOUNT": "هل لديك حساب؟",
    "HAS_SIGNED_IN": "لقد قمت بتسجيل الدخول إلى {spaceName}!",
    "LAST_NAME_PLACEHOLDER": "مثال: Folani",
    "LOGIN": "تسجيل الدخول",
    "NAME_PREVIEW": "سيرى الأعضاء الآخرون أنك:",
    "NO_ACCOUNT": "لا يوجد حساب بعد؟",
    "OAUTH_BUTTONS": {
      "CSAM": "انضم إلى CSAM"
    },
    "PAGE_TITLE": "تسجيل الدخول",
    "SIGNUP": "إنشاء حساب",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "ساعدنا في فهم ما إذا كان نشاط المنصة يمثل سكان العالم بشكل أفضل. سيتم استخدام هذه المعلومات فقط لأغراض التحقق والأغراض الإحصائية المتعلقة بالمشاركة.",
      "PAGE_TITLE": "اخر خطوة!",
      "WELCOME_TOAST": "تهانينا ، أنت مسجل في {spaceName}!"
    },
    "UNLINK": "إلغاء الربط",
    "VERIFY_EMAIL": {
      "CONTENT": "أدخل رمز التحقق الذي تلقيته على {email}.",
      "RESEND": "لم تتلق بريدا إلكترونيا؟ {link}",
      "RESEND_LINK": "إعادة إرسال الكود",
      "RESEND_SUCCESS": "تم إرسال رمز التحقق الجديد إليك.",
      "TITLE": "التحقق من حسابك",
      "VERIFY_ALERT": "تحقق من بريدك الإلكتروني للمشاركة في جميع الاستشارات.",
      "VERIFY_SUCCESS": "تم التحقق بنجاح من حسابك."
    }
  },
  "BACK": "خلف",
  "BUTTONS": {
    "ACCEPT": "قبول",
    "ACCESS_CONSULTATION": "انتقل إلى الاستشارات",
    "ACTIONS": "إجراءات",
    "ADD": "أضف",
    "ADD_ATTACHMENTS": "إضافة ملفات / صور",
    "ADD_NEW_IDEA": "مساهمات",
    "CANCEL": "إلغاء",
    "CHANGE_USER": "تغيير المستخدم",
    "CLEAR": "صافي",
    "CLONE": "نسخ",
    "CLOSE": "إغلاق",
    "COMMENT": "تعليق",
    "CONFIRM": "تأكيد",
    "CONTINUE": "استمر",
    "DELETE": "حذف",
    "DELETE_VOTERS": "حذف المصوتين",
    "DRAG_DROP_ATTACHMENTS": "سحب وإفلات الملفات/الصور هنا أو انقر",
    "EXPORT": "تصدير",
    "EXPORT_PARTICIPANTS": "تصدير المشاركين",
    "EXPORT_PROPOSALS": "تصدير الاقتراحات",
    "EXPORT_RESULTS": "تصدير النتائج",
    "EXPORT_VOTERS": "ناخبون تصدير",
    "FILTER": "فرز",
    "IGNORE": "ليس الآن",
    "IMPORT": "استيراد",
    "IMPORT_VIA_EXCEL": "استيراد ملف Excel",
    "IMPORT_VIA_FORM": "املأ النموذج عبر الإنترنت",
    "IMPORT_VOTERS": "إستيراد المصوتين",
    "IN_PROGRESS": "قيد التقدم",
    "JOIN": "انضم",
    "LEARN_MORE": "اعرف أكثر",
    "NO": "لا",
    "OPEN": "فتح",
    "OPEN_IN_NEW_TAB": "يفتح علامة تبويب جديدة",
    "PUBLISH": "نشر",
    "READ_MORE": "عرض المزيد",
    "REJECT_ALL": "رفض كل شيء",
    "SAVE": "حفظ",
    "SETTINGS": "الإعدادات",
    "SKIP": "تخطى",
    "TRANSLATE_VIA_AI": "الترجمة عبر الذكاء الاصطناعي",
    "UPDATE": "تحديث",
    "UPDATE_PICTURE": "تحديث",
    "UPLOAD_PICTURE": "تحميل الصورة",
    "VERIFY": "انضم إلى حدث الويب",
    "VERIFY_EMAIL": "تحقق من عنوان بريدي الإلكتروني",
    "VIEW_ANSWER": "انظر الجواب",
    "VIEW_IDEAS": "انظر المقترحات",
    "VOTE": {
      "BUDGET": "انا أدعم",
      "NOT_SUPPORT": "أنا لا أؤيد",
      "SUPPORT": "انا أدعم",
      "TOAST": {
        "CANCEL": "تم إلغاء تصويتك",
        "SUCCESS": "تم حفظ تصويتك"
      },
      "VOTE_AGAINST": "أنا أصوت ضد",
      "VOTE_FOR": "أنا أصوت ل"
    },
    "WRITE": "كتابة"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {لا يوجد محتوى} one {{count} محتوى} other {{count} محتويات}}",
  "COMMENTS": {
    "AUTHOR": "مؤلف",
    "CREATE": {
      "PRIVACY_WARNING": "هذا المحتوى سري. يمكن فقط للمؤلف والمؤسسة المستقبلة مشاهدته.",
      "SUBMIT": "يُقدِّم"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "اترك تعليقًا عامًا لشرح تغيير الحالة"
      },
      "ERROR": "الرجاء إكمال هذه الحقول قبل إرسالها.",
      "PLACEHOLDER": "تعليقك",
      "SUCCESS_ANOMALY": "تم إرسال مشاكل الخاص بك.",
      "SUCCESS_DEMAND": "تم ارسال رسالتك.",
      "SUCCESS_IDEA": "وقد تم نشر تعليقك.",
      "VALIDATE": "تحقق"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "كن أول من يعلق!",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "هذا المستخدم ينتظر ردك منذ {date}.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "كن أول من يعلق!",
      "CONTRIBUTION_ENDED": "انتهت المشاورات",
      "CONTRIBUTION_ENDED_ON": "انتهت الاستشارة في {date}",
      "CONTRIBUTION_HAS_NOT_STARTED": "تبدأ الاستشارة في {date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {لا توجد تعليقات} one {{count} تعليق} other {{count} تعليقات}}",
      "COUNT_MESSAGING": "{count, plural, =0 {لا توجد إجابات} one {{count} إجابة} other {{count} إجابات}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {لا يوجد تعليقات} one {{count} تعليق} other {{count} تعليقات}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "لقد تم حذف هذا التعليق",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {لا أجوبة} one {عرض إجابة واحدة} other {عرض {count} إجابات}}",
      "REPLY": "رد"
    },
    "TITLE": "تعليقات"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "تضمن نسبة التباين العالية إمكانية الوصول للأعضاء. وفقًا للمعايير الدولية (WCAG) ، ننصحك باختيار لون بنسبة تزيد عن {النسبة}: 1 (المستوى AA من WCAG الإصدار 2.1)",
    "TEXT": {
      "BAD": "مستوى التباين هو {value}: 1 بهذا اللون. لا يكفي الامتثال لإرشادات الوصول (WCAG level AA).",
      "GOOD": "مستوى التباين هو {value}: 1 بهذا اللون. أعلى من العتبة للامتثال لإرشادات الوصول (WCAG مستوى AA)"
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "سيعمل {providerName} على تعيين ملفات تعريف الارتباط على جهازك إذا كنت ترغب في استخدام هذه الميزة."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "لقد قمت بتفعيل مانع الإعلانات الذي يمنع عرض هذا الفيديو. يرجى تعطيله للاستمرار.",
      "CTA": "اسمح لملفات تعريف الارتباط",
      "VIMEO": "يحتاج Vimeo إلى تعيين ملفات تعريف الارتباط لعرض الفيديو",
      "YOUTUBE": "يحتاج Youtube إلى تعيين ملفات تعريف الارتباط لعرض مقطع فيديو"
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "تصدير الاستشارات",
        "MESSAGING": "تصدير الرسائل",
        "PARTICIPATION": "تصدير الاقتراحات"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {لا توجد تعيينات} one {تعيين واحد} other {{count} تعيينات}}",
      "COMMUNICATION": "{count, plural, =0 {لا أخبار} one {خبر واحد} other {{count} أخبار}}",
      "CONSULTATION": "{count, plural, =0 {بدون استشارات} one {{count} استشارة} other {{count} استشارات}}",
      "FOLDER": "{count, plural, =0 {لا يوجد مجلد} one {{count} مجلد} other {{count} مجلدات}}",
      "FOLDER_CONTENT": "{count, plural, =0 {لا يوجد محتوى} one {محتوى واحد} other {{count} محتويات}}",
      "FORM_RESPONSES": "{count, plural, =0 {لا توجد إجابة} one {{count} إجابة} other {{count} إجابات}}",
      "INVITATIONS": "{count, plural, =0 {لا دعوات} واحدة {{count} دعوة} other {{count} دعوات}}",
      "MESSAGING": "{count, plural, =0 {لا يوجد محتوى} one {محتوى واحد} other {{count} محتويات}}",
      "NEWSLETTERS": "{count, plural, =0 {لا توجد حملات} one {{count} حملة} other {{count} حملات}}",
      "PARTICIPATION": "{count, plural, =0 {لا توجد مقترحات} one {اقتراح واحد} other {{count} مقترحات}}",
      "RANKING": "مرتبة المساهمات",
      "USER": "{count, plural, =0 {ليس هناك أعضاء} one {عضو واحد} other {{count} أعضاء}}",
      "VOTERS": "{count, plural, =0 {لا يوجد ناخب} one {{count} ناخب} other {{count} ناخبين}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {لا توجد أخبار محددة} one {{count} خبر محدد} other {{count} أخبار محددة}}",
      "CONSULTATION": "{count, plural, =0 {لم يتم اختيار أي استشارة} one {{count} استشارة مختارة} other {{count} استشارات مختارة}}",
      "FOLDER": "{count, plural, =0 {لم يتم تحديد أي ملف} one {{count} ملف محدد} other {{count} ملفات محددة}}",
      "FOLDER_CONTENT": "{count, plural, =0 {لا يوجد محتوى محدد} one {{count} محتوى محدد} other {{count} محتويات محددة}}",
      "MESSAGING": "{count, plural, =0 {لم يتم تحديد أي محتوى} one {{count} محتوى محدد} other {{count} محتويات محددة}}",
      "PARTICIPATION": "{count, plural, =0 {لم يتم تحديد مقترحات} one {{count} اقتراح محدد} other {{count} تم تحديد المقترحات}}",
      "VOTERS": "{count, plural, =0 {لا يوجد مصوت محدد} one {{count} مصوت محدد} other {{count} مصوتين محددين}}"
    },
    "EDIT": "تعديل",
    "EMPTY_STATE": {
      "ASSIGNMENT": "سوف تجد هنا المحتوى الذي تم تعيينه لك",
      "COMMUNICATION": "انشر أخبارك الأولى",
      "CONSULTATION": "انشر استشارتك الأولى",
      "FOLDER": "أنشئ أول مجلد",
      "FOLDER_CONTENT": "ستجد هنا محتويات المشروع",
      "FORM_RESPONSES": "ستجد هنا الإجابات على الاستبيان",
      "INVITATIONS": "ستجد هنا قائمة الدعوات.",
      "MESSAGING": "ستجد هنا رسائل وحالات شاذة",
      "NEWSLETTER": "إنشاء أول بريد إلكتروني",
      "PARTICIPATION": "ستجد هنا مقترحات الاستشارة",
      "SEARCH": {
        "BUTTON": "أعد ضبط المرشحات",
        "DESCRIPTION": "تأكد من كتابة بحثك بشكل صحيح أو قم بتغيير عوامل التصفية.",
        "TITLE": "لا نتائج"
      },
      "USER": "ستجد هنا قائمة الأعضاء المسجلين.",
      "VOTERS": "سوف تجد هنا المصوتين في الاستشارة"
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "المدينة",
        "PLACEHOLDER": "تصفية حسب المدينة"
      },
      "BLANK": "لم يتم التحديد",
      "FOLDER": {
        "LABEL": "مجلد",
        "PLACEHOLDER": "تصفية حسب المجلد"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "مسودة",
        "SCHEDULED": "مجدولة",
        "SENT": "تم الإرسال"
      },
      "PROF_CATEGORY": {
        "LABEL": "الفئة المهنية",
        "PLACEHOLDER": "تصفية حسب الفئة المهنية"
      },
      "REGISTERED": {
        "LABEL": "مسجل",
        "PLACEHOLDER": "التصفية حسب التسجيل",
        "REGISTERED": "مسجل",
        "UNREGISTERED": "غير مسجل"
      },
      "ROLES": {
        "ADMINISTRATOR": "مدير",
        "AUTHOR": "مؤلف",
        "CITIZEN": "المستعمل",
        "CONTRIBUTOR": "مدير",
        "LABEL": "دور",
        "PLACEHOLDER": "تصفية حسب الدور"
      },
      "SEX": {
        "LABEL": "الجنس",
        "PLACEHOLDER": "تصفية حسب الجنس"
      },
      "STATUS": {
        "ANSWERED": "لم يتم اختياره",
        "DOING": "تحت الفحص",
        "DONE": "مُنفّذ",
        "DUPLICATE": "مجمعة",
        "IN_PROGRESS": "قيد التقدم",
        "LABEL": "حالة",
        "MESSAGING": {
          "DOING": "تحت الفحص",
          "DONE": "أجاب",
          "LABEL": "حالة",
          "PLACEHOLDER": "تصفية حسب الحالة",
          "TODO": "مُقَدَّم"
        },
        "PLACEHOLDER": "اختر الحالة",
        "PLANNED": "مخطط",
        "REJECTED": "رفض",
        "SELECTED": "المحدد",
        "TODO": "مُقَدَّم",
        "TO_MODERATE": "À مراجعة",
        "VALIDATED": "الفائز"
      },
      "TAG": {
        "LABEL": "عنوان",
        "PLACEHOLDER": "تصفية حسب الموضوع"
      },
      "TYPES": {
        "ANOMALY": "مشكلة",
        "ARTICLE": "مقالة",
        "COLLABORATIVE_DECISION": "القرارات التعاونية",
        "DEMAND": "رسالة",
        "EVENT": "حدث",
        "FOLDER": "مجلد",
        "IDEA": "مقترح",
        "IDEAS_REQUEST": "دعوة لتقديم مقترحات",
        "LABEL": "نوع المحتوى",
        "PARTICIPATORY_BUDGET": "الميزانية التشاركية",
        "PLACEHOLDER": "تصفية حسب النوع",
        "STUDY": "استبيان",
        "SURVEY": "استبيان"
      },
      "USER_TYPE": {
        "DESCRIPTION": "متصل أو غير متصل",
        "LABEL": "مشاركة",
        "OFFLINEUSER": "غير متصل",
        "PLACEHOLDER": "تصفية حسب نوع المشاركة",
        "USER": "عبر الإنترنت"
      },
      "VISIBILITY": {
        "DRAFT": "مسودة",
        "LABEL": "الرؤية",
        "PLACEHOLDER": "تصفية حسب الرؤية",
        "PLANNED": "مخطط",
        "PUBLISHED": "منشور"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "يتم حفظ التصفيات لجميع المديرين والإداريين المصرح لهم.",
      "NO_FILTERABLE_QUESTIONS": "لا توجد فلاتر متاحة",
      "SECTION_TITLE_FORM": "معلومات النموذج",
      "SECTION_TITLE_PARTICIPANTS": "المشاركون",
      "TITLE": "تصفية"
    },
    "MENU": {
      "ASSIGNMENT": "تعيينات",
      "COMMUNICATION": "أخبار",
      "CONSULTATION": "إستشارات",
      "FOLDER": "ملفات",
      "GENERAL": "عام",
      "MESSAGING": "البريد الإلكتروني",
      "NEWSLETTER": "النشرات الإخبارية",
      "PARTICIPATION": "مشاركة",
      "SETTINGS": "الإعدادات",
      "SETTINGS_ACCESS": "الوصول",
      "SETTINGS_COMMUNICATION": "الاتصال",
      "SETTINGS_GENERAL": "عام",
      "SETTINGS_LEGAL": "نصوص قانونية",
      "SETTINGS_PAGES": "صفحات",
      "STATS": "عرض مسبق",
      "USER": "المستخدمون"
    },
    "NEWSLETTERS": "الحملات",
    "PARTICIPATION": "مشاركة",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "نشط",
        "APPLICATION_FILE_LABEL": "استيراد قالب لملف تطبيق مفصل",
        "APPLICATION_FILE_TOOLTIP": "لطلب معلومات إضافية من الأعضاء عند تقديم فكرة جديدة ، يمكنك تقديم قالب ملف تطبيق مفصل لهم. <br> </br> <b> أنواع الملفات: </b> .pdf ، .doc ، .docx ، .txt ، .odt ، .rtf ، .md",
        "DESCRIPTION": "يتم استخدام نموذج التقديم للمعلومات التي يجب على العضو ملءها لتقديم الفكرة.",
        "REQUIRED": "مطلوب",
        "TITLE": "نموذج التقديم"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "إعدادات الأخبار"
        },
        "CONSULTATION": {
          "TITLE": "معلمات الاستشارة"
        },
        "FOLDER": {
          "TITLE": "المجلد الإعدادات"
        }
      },
      "TABS": {
        "ANALYSIS": "تحليل",
        "APPEARANCE": "عام",
        "DISABLED_TOOLTIP": "املأ واحفظ النموذج الحالي للوصول إلى هذا",
        "IMPLEMENTATION": "تنفيذ",
        "MANAGERS": "مديرين",
        "PRESENTATION": "عرض",
        "PUBLIC_FILTERS": "الفلاتر العامة",
        "QUESTIONS": "أسئلة",
        "SECURITY": "أمان",
        "SETTINGS": "الإعدادات",
        "SUBMISSION": "إيداع",
        "VOTE": "إقتراع"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "إضافة بحث متقدم إلى استشارتك لتمكين مستخدميك من تصفية المساهمات على صفحتك.",
      "TITLE": "مرشحات عامة"
    },
    "SHOW": "يعرض",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "الصفحة الأولى",
        "LAST_PAGE": "آخر صفحة",
        "NEXT_PAGE": "الصفحة التالية",
        "PREVIOUS_PAGE": "الصفحة السابقة"
      },
      "BUTTONS": {
        "ACTIONS": "إجراءات",
        "CHANGE_STATUS": "تغيير الوضع",
        "DELETE": "حذف"
      },
      "PAGINATION": "{from} - {to} من {count}",
      "TITLES": {
        "ACTIONS": "إجراءات",
        "ASSIGNED": "مُكَلَّف",
        "AUTHOR": "مؤلف",
        "BIRTHDATE": "تاريخ الميلاد",
        "BUDGET": "كلفة",
        "COMMENTS_COUNT": "تعليقات",
        "COMMUNICATIONS_COUNT": "أخبار",
        "CONSULTATION": "استشارة",
        "CONSULTATIONS_COUNT": "استشارات",
        "CONSULTATION_TITLE": "عنوان الاستشارة",
        "CONTRIBUTION": "المساهمة",
        "CREATED_AT": "تاريخ الدعوة",
        "EMAIL": "البريد الإلكتروني",
        "FIRST_NAME": "الاسم الاول",
        "FOLDER": "مجلد",
        "FOLDERS_COUNT": "ملفات",
        "HAS_ACCESS": "لديه حق الوصول",
        "ID": "بطاقة تعريف",
        "IDEAS_COUNT": "الاقتراح",
        "LAST_NAME": "اللقب",
        "LAST_VOTE_AT": "تاريخ التصويت",
        "NEWSLETTER_CREATED_AT": "أنشئت في",
        "NEWSLETTER_SENT_AT": "أرسلت في",
        "NEWSLETTER_SUBJECT": "موضوع",
        "NEWSLETTER_TITLE": "الحملة",
        "PARTICIPATION_TYPE": "مشاركة",
        "PICTURE": " ",
        "PUBLICATION_DATE": "النشر",
        "RECIPIENTS": "المستلمون",
        "RESPONSE_DATE": "تاريخ",
        "ROLE": "دور",
        "SENT_AT": "أرسلت في",
        "SOURCE": "مشاركة",
        "STATE": "حالة",
        "STATUS": "حالة",
        "SUBSCRIPTION_DATE": "تاريخ الاشتراك",
        "TITLE": "عنوان",
        "TOPIC": "عنوان",
        "TYPE": "نوع",
        "USER": "المستخدم",
        "VISIBILITY": "الرؤية",
        "VOTES_AGAINST_COUNT": "مجموع الأصوات ضد",
        "VOTES_COUNT": "التصويتات",
        "VOTES_FOR_COUNT": "مجموع الأصوات لـ"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "YYYY / MM / DD"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {آخر يوم} one {يوم واحد متبقي} two {يومان متبقيان} few {{count} أيام متبقية} other {{count} يوما متبقيا}}",
    "INVALID_LABEL": "غير صالح",
    "IN_N_DAYS": "يبدأ {count}",
    "LABEL": {
      "DEFAULT": "اختر التاريخ",
      "SCHEDULE_LABEL": "جدولة على",
      "SCHEDULE_TITLE": "جدولة النشر"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "محتوى البريد الإلكتروني",
        "PLACEHOLDER": "مرحبًا، ..."
      },
      "DELETED_USER_WARNING": "طلب هذا المستخدم حذف حسابه. لا يمكنك الاتصال به.",
      "SEND": "إرسال",
      "SUBJECT": {
        "LABEL": "موضوع البريد الإلكتروني",
        "PLACEHOLDER": "طلب لمزيد من المعلومات حول ..."
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {لا توجد ملاحظات خاصة} one {ملاحظات خاصة واحدة} other {{count} ملاحظات خاصة}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "اكتب ملاحظة خاصة",
        "PUBLIC": "تعليقك"
      },
      "INFO": "احرص على عدم كتابة تعليقات تحتوي على بيانات تعتبر حساسة.",
      "INFO_TOOLTIP": "الأصل العرقي أو الإثني ، والآراء السياسية أو الفلسفية أو الدينية ، والعضوية النقابية ، والبيانات الصحية ، والتفضيل الجنسي ، والسجل الجنائي ، ...",
      "NO_COMMENTS": "كن أول من يكتب ملاحظة خاصة"
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# تم تجميع اقتراح مشابه مع هذا الاقتراح الواحد} one {{count} اقتراح مشابه مع هذا الاقتراح  تم تجميع} other {{count} مقترحات المماثلة تم تجميعها مع هذا الاقتراح}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "العوده للصفحة الرئيسية",
    "CTA_NO_SPACE": "تصفح المساحات المتاحة",
    "FORMER_CLIENT_TOAST": "المساحة التي تحاول الوصول إليها غير موجودة أو تم إغلاقها.",
    "NOT_FOUND": {
      "DESCRIPTION": "يبدو أننا أخذناك في الطريق الخطأ. لنبدأ من جديد؟",
      "TITLE": "عذرا ، لم نتمكن من العثور على الصفحة التي تبحث عنها."
    },
    "OFFLINE": {
      "DESCRIPTION": "يبدو أنك غير متصل بالإنترنت. دعونا تحديث؟",
      "TITLE": "عذرا ، لم نتمكن من العثور على الصفحة التي تبحث عنها."
    },
    "RELOAD": "إعادة تحميل",
    "SERVER_ERROR": {
      "DESCRIPTION": "كن مطمئنًا أن المطورين لدينا يبذلون قصارى جهدهم لإصلاحها. يجب أن نعود قريبا.",
      "TITLE": "عفوًا ، حدث خطأ غير متوقع."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "يتوفّر للجميع",
    "ETHICAL_POLICY": "ميثاق الأخلاق",
    "HELP": "مساعدة",
    "LEGAL_NOTICE": "الشروط القانونية",
    "PRIVACY_POLICY": "سياسة الخصوصية",
    "TERMS_OF_USE": "شروط الاستخدام"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "يجب عليك ملء الحقول بشكل صحيح.",
      "REQUIRED": "يجب ملء هذا المجال."
    },
    "SELECT_EMPTY_LABEL": "غير محدد",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "تمت عملية الحذف بنجاح",
      "UPDATED_SUCCESSFULLY": "تم تحديث المعلومات بنجاح."
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "تمت الإجابة في <b>{date}</b> على الساعة <b>{time}</b>",
    "SHOW_RESPONSE": "انظر إلى إجابتي",
    "SUBMISSION_NOT_ONGOING": "انتهت الاستشارة، لا يمكنك الرد أو تعديل إجابتك.",
    "UPDATE_RESPONSE": "تعديل إجابتي"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "هل أنت متأكد من أنك تريد حذف هذا العنصر؟",
    "CTA": "نعم، احذف",
    "TITLE": "حذف"
  },
  "HOME": {
    "PAGE_TITLE": "مرحبا بكم في فلويسيتي",
    "SEARCH_PLACEHOLDER": "اكتب اسم الفضاء",
    "SUBTITLE": "ابحث عن المساحة المناسبة لبدء المساهمة:"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "فشل تحميل الصورة",
    "LOADING": "تحميل الصورة"
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "لإضافة عدة مساهمات تم استلامها خارج المنصة، {link} دون تعديل تنسيقها.<br></br>إذا لم تقم بجمع بعض المعلومات، يرجى عدم حذف الأعمدة وتركها فارغة.<br></br>إذا كانت مساهماتك بعدة لغات، يرجى ترجمتها جميعًا إلى {defaultLang} قبل استيرادها.",
        "LINK": "املأ النموذج",
        "TITLE": "استيراد المساهمات"
      },
      "STATUS": {
        "DESCRIPTION": "تحديد حالة المساهمات أثناء الاستيراد",
        "TITLE": "اختر الحالة"
      }
    },
    "ERROR": {
      "DESCRIPTION": "من المستحيل استيراد ملفك. تحقق من أن ملفك يتبع النموذج بشكل صحيح.",
      "EXPLANATION": "تأكد من عدم حذف أي عمود وأن الإجابات تتوافق مع التنسيق المطلوب.",
      "ROWS_MULTIPLE": "تعذر استيراد ملفك. تم تحديد أخطاء في السطور {rows}.",
      "ROWS_SINGLE": "تعذّر استيراد الملف الخاص بك. تم تحديد خطأ في السطر {rows}.",
      "ROWS_WITH_MORE": "تعذّر استيراد الملف الخاص بك. تم تحديد أخطاء في الأسطر {rows} و {moreCount} أخرى."
    },
    "FORM": {
      "CTA": "المستورد",
      "UPLOAD_DATE": "{size} - تحديث في {date}",
      "UPLOAD_TITLE": "سحب الملف أو النقر"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "لإضافة عدة ردود تم استلامها خارج المنصة، {link} بدون تعديل تنسيقها.<br></br>إذا لم تقم بجمع بعض المعلومات، يُرجى عدم حذف الأعمدة وتركها فارغة.<br></br>إذا كانت ردودك بلغات متعددة، يُرجى ترجمتها جميعًا إلى {defaultLang} قبل استيرادها.",
        "LINK": "املأ النموذج",
        "TITLE": "استيراد الإجابات"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "تحقق من تطابق معلومات الاستيراد الخاصة بك مع أعمدة النموذج.<br></br>إذا لم تتطابق بعض المعلومات، يجب عليك تعديل ملفك ثم استيراد الملف المحدث الخاص بك.",
      "TITLE": "التحقق من البيانات"
    },
    "PROGRESS": "استيراد قيد التقدم...",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "لإضافة التصويتات التي تم استلامها خارج المنصة، {link} دون تغيير الشكل. إذا لم تجمع بعض المعلومات، يرجى <b>عدم حذف الأعمدة</b> وتركها فارغة.",
        "LINK": "املأ النموذج",
        "TITLE": "استيراد التصويتات"
      }
    }
  },
  "JOIN": "انضم",
  "JOINED_SPACE": "مرحبًا بك في {space}!",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "سنبقيك على اطلاع إذا تم إصدار الاستشارات الخاصة بك في المستقبل. يمكنك أيضًا العثور على مساحات أخرى موجودة باستخدام شريط البحث أدناه وتسجيل الدخول باستخدام حسابك الحالي.",
      "CONTENT_NOT_FOUND": "للمشاركة في الاستشارة مرة أخرى ، ستحتاج إلى إعادة إنشاء حساب.",
      "TITLE": "شكرا لاختيارك إبقاء حسابك نشطًا.",
      "TITLE_NOT_FOUND": "لم يعد حسابك موجودًا أو تم إخفاء هويتك بالفعل!"
    }
  },
  "LOADING_MORE": "جارٍ تحميل المزيد…",
  "LOAD_MORE": "تحميل المزيد",
  "MENU_ITEMS": {
    "DESCRIPTION": "تخصيص علامات التبويب التي تظهر في شريط التنقل الخاص بك.",
    "FORM": {
      "ADD_ITEM": "إضافة علامة التبويب",
      "ADD_SUBITEM": "إضافة علامة تبويب فرعية",
      "INPUTS": {
        "LABEL": {
          "LABEL": "تسمية",
          "PLACEHOLDER": "تحديد عنوان علامة التبويب الخاصة بك"
        },
        "LINK": {
          "LABEL": "رابط خارجي",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "الصفحة الافتراضية",
          "PLACEHOLDER": "حدد صفحة"
        },
        "POST": {
          "LABEL": "محتوى",
          "NO_OPTIONS": "لا توجد محتوى",
          "PLACEHOLDER": "انضم إلى الحدث"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "أخبار",
          "CONSULTATION": "الاستشارات",
          "FOLDER": "ملف",
          "LABEL": "نوع المحتوى",
          "PLACEHOLDER": "تحديد نوع المحتوى"
        },
        "TYPE": {
          "LABEL": "اطبع",
          "PLACEHOLDER": "تحديد نوع"
        }
      }
    },
    "GROUP": "قائمة منسدلة",
    "LINK": "رابط خارجي",
    "NEW_GROUP": "قائمة منسدلة جديدة",
    "NEW_ITEM": "عنصر جديد",
    "PAGE": "الصفحة الافتراضية",
    "PAGE_ABOUT": "حول",
    "PAGE_CONSULTATIONS": "استشارات",
    "PAGE_NEWS": "أخبار",
    "PAGE_SEARCH": "بحث",
    "POST": "محتوى",
    "TITLE": "شريط التنقل الخاص بك"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "الإبلاغ عن مشكلة"
    },
    "DEMAND": {
      "REPORT_CTA": "ارسل رسالة"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "الطلاقة هي حل لإشراك المواطنين ، والذي يسمح باتخاذ قرارات جماعية حول الموضوعات ذات الاهتمام العام.",
    "PAGES_TITLES": {
      "ABOUT": "حول | {spaceName}",
      "CONSULTATIONS": "الاستشارات | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "رسائلي ومشاكلي | {spaceName}",
        "PROPOSALS": "مقترحاتي | {spaceName}"
      },
      "DASHBOARD": "لوحة القيادة | {spaceName}",
      "LEGAL_NOTICE": "الشروط القانونية | {spaceName}",
      "NEWS": "الأخبار | {spaceName}",
      "PRIVACY_POLICY": "سياسة الخصوصية | {spaceName}",
      "SEARCH": "بحث | {spaceName}",
      "SETTINGS": "حسابي | {spaceName}",
      "TERMS_OF_USE": "شروط الاستخدام | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName}: اكتشف هذا المقال عن الطلاقة!",
      "EVENT": "{cityName}: شارك في هذا الحدث!",
      "FOLDER": "{title} {url} عبرFluicity Engage",
      "IDEA": "ادعم هذا الاقتراح: {title} {url} عبرFluicity Engage"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{title}",
      "IDEA": "ادعم هذا الاقتراح: {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "يمكنك تعديل مساهمتك أو تقديمها كما هي. ستقوم الخدمات بتقييم ما إذا كان يمكن نشر مساهمتك أم لا.",
      "REASON": "السبب:",
      "SUBMIT": "إرسال",
      "TITLE": "تم تحديد مساهمتك كمشبوهة."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "YYYY-MM-DD",
      "PLACEHOLDER": "YYYY-MM-DD"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "لوحة القيادة",
    "MY_ACCOUNT": "حسابي",
    "MY_PROFILE": "ملفي"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "تم إرسال هذه الحملة بالفعل",
    "CREATED_AT": "تم إنشاؤه في <b>{date}</b> في <b>{time}</b>",
    "DRAFT": "مسودة",
    "FORM": {
      "CLEAR_SCHEDULING": "إلغاء الجدولة",
      "CONTENT": {
        "LABEL": "نص البريد الإلكتروني",
        "PLACEHOLDER": "اكتب نص بريدك الإلكتروني هنا"
      },
      "RECIPIENTS": {
        "ALL": "جميع الأعضاء",
        "LABEL": "المستلمون",
        "PLACEHOLDER": "حدد مستلمي البريد الإلكتروني"
      },
      "SAVE_SUCCESS": "تم حفظ حملتك بنجاح",
      "SCHEDULE": "جدولة",
      "SCHEDULED_AT": "التاريخ والوقت المحدد",
      "SEND": "إرسال",
      "SEND_SUCCESS": "تم إرسال حملتك بنجاح",
      "SEND_TEST": "إرسال الاختبار",
      "SUBJECT": {
        "LABEL": "موضوع البريد الإلكتروني",
        "PLACEHOLDER": "اكتب عنوانًا يجذب الأعضاء:"
      },
      "TEST_EMAIL": {
        "LABEL": "عناوين البريد الإلكتروني للاختبار",
        "PLACEHOLDER": "أدخل عناوين البريد الإلكتروني للاختبار مفصولة بفاصلة"
      },
      "TEST_SUCCESS": "تم إرسال الحملة الاختبارية بنجاح"
    },
    "IMMEDIATELY": "بشكل فوري",
    "NEW_NEWSLETTER": "إنشاء حملة",
    "SCHEDULED": "مجدول",
    "SENT": "أرسلت",
    "SENT_AT": "أرسلت في <b>{date}</b> في <b>{time}</b>",
    "UPDATE_NEWSLETTER": "تحديث الحملة",
    "USERS_FILTER_COUNT": "{count, plural, =0 {تحذير، لم يتم العثور على أي مستلم لهذا الاختيار} one {سيتم إرسال النشرة الإخبارية الخاصة بك إلى شخص واحد} other {سيتم إرسال النشرة الإخبارية الخاصة بك إلى {count} أشخاص}}"
  },
  "NEXT": "التالي",
  "NONE": "لا شيء",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "استشارات:<br /> • مقترحات جديدة<br /> • ردود جديدة على الاستطلاعات<br /> • عندما يرد مواطن على أحد تعليقاتي<br /> • عندما تنتهي الخطوة أو الاستشارة قريبًا<br /><br /> المراسلة:<br /> • رسائل جديدة<br /> • حالات شاذة جديدة<br /> • عندما يرد مواطن على أحد تعليقاتي",
        "SUBTITLE": " (اليومي)",
        "TITLE": "أحدث الأنشطة"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• تعديل اقتراح من قبل مؤلفه<br /> • الإشراف على المحتوى من قبل فريق الطلاقة",
        "TITLE": "آخر"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• استشارة جديدة<br /> • بدء مرحلة التفكير أو التصويت أو النتائج",
        "TITLE": "استشارات"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• التعليق أو التصويت على اقتراحي<br /> • الرد على تعليقي<br /> • تغيير وضع اقتراحي",
        "SUBTITLE": " (اليومي)",
        "TITLE": "أحدث أنشطتك"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• النشرات الإخبارية المتعلقة بنشاط المنصة",
        "TITLE": "النشرات الإخبارية"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• حذف اقتراح قمت بالتعليق عليه<br /> • الإشراف على المحتوى الذي علقت عليه",
        "TITLE": "آخر"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• مقالات جديدة<br /> • أحداث جديدة<br /> • مقترحات مميزة",
        "SUBTITLE": " (أسبوعي)",
        "TITLE": "حاليا في الفضاء"
      }
    },
    "INFO_BOX_TEXT": "حدد هنا إشعارات البريد الإلكتروني التي تريد تلقيها من المنصة."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "لماذا ا؟",
    "EXTREMELY_LIKELY": "من المرجح للغاية",
    "NOT_LIKELY": "غير محتمل",
    "TITLE": "أخبرنا برأيك في الطلاقة",
    "VALUE_QUESTION": "ما مدى احتمالية أن توصي بطلاقة لزميلك؟"
  },
  "OFFLINE": "غير متصل",
  "ONLINE": "متصل",
  "OR": "أو",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "لا يمكن اختيار أي اقتراح",
    "TITLE": "تم تجميع هذا الاقتراح مع الاقتراح المماثل التالي"
  },
  "PAGE_OF": "الصفحة {current} من {total}",
  "PASSWORD_RESET": {
    "ACTION": "تحديث",
    "ARIA_LABEL": "تبديل رؤية كلمة المرور",
    "PAGE_TITLE": "أنشئ كلمة مرور جديدة",
    "TITLE": "أنشئ كلمة مرور جديدة",
    "TOAST": "تم حفظ كلمة المرور الجديدة."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "العودة إلى الصفحة الرئيسية",
    "LINK_SENT": "إذا تم إقران حساب بالبريد الإلكتروني <strong>{email}</strong> ، فستتلقى رابط إعادة التعيين.<br></br><br></br> إذا كنت لا ترى بريدًا إلكترونيًا ، فتحقق من بريدك الإلكتروني العشوائي.",
    "PAGE_TITLE": "اعد ضبط كلمه السر",
    "RESET": "إعادة تعيين",
    "SUB_TITLE": "نسيت رقمك السري؟ يحدث للجميع! سنرسل لك بريدًا إلكترونيًا يحتوي على رابط لإعادة تعيينه.",
    "TITLE": "اعد ضبط كلمه السر"
  },
  "PICTURE_PICKER": {
    "COVER": "اختر صورة لتوضيح المنشور الخاص بك"
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "تم الإنشاء في {date}",
      "MODAL": {
        "AFTER": "بعد التغيير",
        "BEFORE": "قبل التغيير",
        "TITLE": "التحديثات"
      },
      "NO_AUDITS": "لم يتم تحديث هذا الاقتراح بعد.",
      "UPDATE": "تم التحديث في {date}"
    },
    "AUTHOR": "المؤلف",
    "BUDGET": {
      "ALERT": "يجب عليك <b>ملء تكلفة</b> الاقتراح قبل تعريفه على أنه &quot;محدد&quot;.",
      "BUDGET_VALUE": "تكاليف هذا العرض <b>{budget}</b>",
      "MODAL_LABEL": "ميزانية",
      "MODAL_TITLE": "املأ التكلفة",
      "NOT_ENOUGH_BUDGET": "الميزانية المتبقية غير كافية.",
      "NOT_SELECTED": "لم يتم اختيار هذا الاقتراح لمرحلة التصويت.",
      "REMAINING_BUDGET": "لا يزال لديك <strong>{remaining}</strong> لإنفاقها"
    },
    "CARD": {
      "CONTRIBUTE": "مساهمة",
      "PARTICIPATE": "مشاركة",
      "READ_MORE": "اقرأ أكثر",
      "VOTE": "تصويت"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {لا اصوات} one {صوت واحد} other {{progress} أصوات}}",
        "TOOLTIP_2": "{total, plural, =0 {من {total} من المقترحات} one {من {total} اقتراح} other {من {total} اقتراحات}}"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "عرض",
          "TEXT_1": "أو إذا كنت تريد أن تذهب أبعد من ذلك",
          "TEXT_2": "دعونا نقدم اقتراح!"
        },
        "VOTE_CARD": {
          "CTA": "تصويت",
          "TEXT_1": "تصفح الاقتراحات {emoji}",
          "TEXT_2": "هل تريد الاستمرار؟",
          "TEXT_3": "أو الوصول إلى القائمة الكاملة"
        }
      }
    },
    "CLONE": {
      "ACTION": "ينسخ",
      "CANCEL": "لا",
      "CONFIRM": "نعم، تكرار",
      "CONTENT_CLONED": "تم نسخ هذا المحتوى بنجاح.",
      "DESCRIPTION": "هل ترغب حقًا في نسخ هذا المحتوى؟",
      "SUCCESS": "هذا المحتوى تم حذفه."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {تعليق} one {تعليق} other {تعليقات}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "كن أول من يشارك!",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {المشاورات} one {{count} استشارة} other {{count} استشارات}}",
      "ENDED_AT": "انتهت الاستشارة في {date}",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {لا توجد مقترحات} one {# اقتراح} other {# مقترحات}}",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {لا توجد مساهمات محلية} one {مساهمة محلية واحدة} other {# مساهمات محلية}}"
      },
      "MAP_TOOLTIP": "المساهمات غير الموقعة جغرافيا لا تظهر على الخريطة. يمكن أن تحتوي المساهمة على عدة مواقع.",
      "NEWS_COUNT": "{count} الأخبار",
      "ONGOING_TEXT": "قم بزيارة هنا للمشاركة.",
      "PARTICIPATE_OFF": "عد لاحقًا لتتمكن من المساهمة",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "اكتشف النتائج",
        "PARTICIPATE": "شارك في الاستشارة"
      },
      "SEE_OWN_VOTES": "إظهار أصواتي فقط",
      "STARTS_AT": "تبدأ الاستشارة في {تاريخ}",
      "STEP_ENDED_AT": "انتهت مرحلة \"{step}\" في {date}",
      "STEP_STARTS_AT": "تعال في {date} لاكتشاف المرحلة \"{step}\""
    },
    "CONTENT_DELETED_SUCCESSFULLY": "تم حذف المحتوى",
    "CREATE_MENU": {
      "ACTIONS": "أجراءات",
      "ADDED_TO_FOLDER_TOAST": "تمت إضافة المحتوى إلى الملف.",
      "ADD_TO_FOLDER": "إضافة إلى مجلد",
      "ARTICLE": {
        "DESCRIPTION": "أبلغ الأعضاء"
      },
      "ASSIGN": "تعيين",
      "BUTTON": "أنشئ",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "تنفيذ المقترحات التي تم إنشاؤها جنبًا إلى جنب مع الأعضاء"
      },
      "CONTACT_AUTHOR": "مؤلف الاتصال",
      "DIALOG_TITLE": {
        "COMMUNICATION": "إنشاء أخبار",
        "CONSULTATION": "إنشاء قنصلية"
      },
      "EDIT": "تعديل",
      "EVENT": {
        "DESCRIPTION": "قم بدعوة الأعضاء إلى اجتماع"
      },
      "FOLDER": {
        "DESCRIPTION": "إنشاء صفحة لتجميع المحتوى"
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "اجمع مقترحات حول مواضيعك الرئيسية"
      },
      "MERGE": "تجميع الاقتراح",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "تخصيص ميزانية للمقترحات التي تم إنشاؤها جنبًا إلى جنب مع الأعضاء"
      },
      "PIN": "تثبيت",
      "REMOVED_FROM_FOLDER_TOAST": "المحتوى تمت إزالته من الملف.",
      "REPORT": "تقرير",
      "STEPS_COUNT": "{count, plural, one {# خطوة} other {# خطوات}}",
      "STUDY": {
        "DESCRIPTION": "أدرج استبيانًا تم إنشاؤه خارج المنصة",
        "TITLE": "استبيان - تكامل"
      },
      "SURVEY": {
        "DESCRIPTION": "استطلع آراء المستخدمين حول موضوع محدد وجمع معلومات متنوعة"
      },
      "UNPIN": "إلغاء التثبيت",
      "UNPUBLISH": "إلغاء النشر",
      "UPDATE_BUDGET": "املأ التكلفة",
      "UPDATE_STATUS": "تغيير الوضع",
      "VIEW": "انظر المنشور",
      "VIEW_IN_DASHBOARD": "لوحة القيادة",
      "VIEW_POST": "رأي آخر"
    },
    "DELETE": {
      "ACTION": "حذف",
      "CANCEL": "لا",
      "CONFIRM": "حذف",
      "CONTENT_DELETED": "تم حذف هذا المحتوى.",
      "DESCRIPTION": "هل أنت متأكد أنك تريد حذف هذا المحتوى؟",
      "PLACEHOLDER": "أضف تعليقًا لتفاصيل الحذف.",
      "REASON": "تعليق",
      "SELECT_REASON": "وضح سبب حذف هذا المحتوى:",
      "SUCCESS": "تم حذف المحتوى."
    },
    "DETAILS": {
      "AUTHORED_BY": "يحمله {name}",
      "DESCRIPTION_TITLE": "الوصف",
      "EVENT": {
        "ACCESS_THE_EVENT": "الوصول إلى الحدث",
        "EVENT_URL": "اجتماع عبر الإنترنت",
        "STATE": {
          "FUTURE": "يبدأ الحدث في <b>{date}</b> الساعة <b>{time}</b> .",
          "ONGOING": "حدث مستمر",
          "PAST": "انتهى الحدث"
        }
      },
      "MORE_TAGS": "{count , plural, one {وموضوع آخر} other {و {count} مواضيع أخرى}}",
      "STUDY": {
        "JOIN_BUTTON": "انضم",
        "JOIN_DESCRIPTION": "تسجيل الدخول أو التسجيل للوصول إلى الاستبيان!",
        "PARTICIPATE": "مشاركة",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "يبدأ الاستطلاع في {date}.",
          "ENDED": "انتهى الاستطلاع في {date}.",
          "ONGOING_ANSWERED": "شكرا على مشاركتك ، لقد تم أخذها في الاعتبار."
        },
        "SEE_RESULTS": "انظر النتائج"
      },
      "UPDATE_MY_IDEA": "تحديث اقتراحي"
    },
    "EXPORT": {
      "BUTTON": "تصدير",
      "IDEAS": "كل المقترحات",
      "MESSAGES": "كل الرسائل"
    },
    "FILTER_BY_IS_PINNED": "مثبت",
    "FILTER_BY_PUBLISHED": "نشرت",
    "FILTER_BY_STATUS": "حالة",
    "FILTER_BY_TAGS": "عنوان",
    "FILTER_BY_TYPE": "نوع المحتوى",
    "FILTER_IS_PINNED_TRUE": "نعم",
    "FILTER_PUBLISHED_FALSE": "غير منشور",
    "FILTER_PUBLISHED_TRUE": "نشرت",
    "FILTER_STATUS_ANSWERED": "لم يتم اختياره",
    "FILTER_STATUS_DOING": "تحت الفحص",
    "FILTER_STATUS_DONE": "مُنفّذ",
    "FILTER_STATUS_IN_PROGRESS": "قيد التقدم",
    "FILTER_STATUS_SELECTED": "المحدد",
    "FILTER_STATUS_TODO": "مُقَدَّم",
    "FILTER_STATUS_VALIDATED": "الفائز",
    "FILTER_TYPE_ANOMALY": "مشكلة",
    "FILTER_TYPE_ARTICLE": "مقالة",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "القرارات التعاونية",
    "FILTER_TYPE_DEMAND": "رسالة",
    "FILTER_TYPE_EVENT": "حدث",
    "FILTER_TYPE_FOLDER": "مجلد",
    "FILTER_TYPE_IDEA": "اقتراح",
    "FILTER_TYPE_IDEAS_REQUEST": "دعوة لتقديم مقترحات",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "الميزانية التشاركية",
    "FILTER_TYPE_STUDY": "استبيان",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "منفتح على المقترحات الجديدة"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "موقع",
        "PLACEHOLDER": "أضف مكانًا"
      },
      "CATEGORIES": {
        "LABEL": "المواضيع",
        "PLACEHOLDER": "حدد مواضيع الاستشارة",
        "SELECT_ALL": "اختر الكل"
      },
      "CATEGORY": {
        "LABEL": "عنوان",
        "PLACEHOLDER": "اختر الموضوع"
      },
      "CONTENT": "وصف",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "إضافة ملف / صورة",
          "ADD_PICTURE": "أضف صورة",
          "DELETE_PICTURE": "حذف"
        },
        "ERRORS": {
          "FILE_SIZE": "يجب ألا يتجاوز حجم الملف {fileSize} ميغا بايت.",
          "FILE_TYPE": "يجب أن تكون الصور بتنسيق {fileTypes}."
        },
        "TOOLTIP": "<b>الحجم الموصى به:</b> {width} (width) x {height} بكسل (height)<br></br> <b>أنواع الملفات:</b> jpg. و jpeg. و png"
      },
      "PIN": "تم تثبيت هذا المحتوى.",
      "TITLE": "عنوان",
      "UNPIN": "لم يعد هذا المحتوى مثبتًا."
    },
    "HOW_IT_WORKS": {
      "TITLE": "كيف يعمل؟"
    },
    "INDICATORS": {
      "ATTENDEES": "الحاضرين",
      "COMMENTS": "تعليقات",
      "COMMUNICATIONS": "أخبار",
      "CONSULTATIONS": "استشارات",
      "IDEAS": "اقتراحات",
      "VOTES": "الأصوات"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "أكمل المحادثة",
      "GIVE_YOUR_OPINION": "اعطي رأيك"
    },
    "PREVIEW": "معاينة على الموقع",
    "PUBLIC_STUDY": "الدراسة العامة",
    "PUBLISHED": "منشور",
    "PUBLISHED_AT": "تم النشر في {date}",
    "PUBLISH_CANCELED": "تم إلغاء نشر هذا المحتوى",
    "PUBLISH_EDIT": "تغيير النشر",
    "PUBLISH_NOW": "نشر الآن",
    "PUBLISH_NOW_TOASTER": "المحتوى الخاص بك هو الآن مرئي للأعضاء",
    "PUBLISH_SCHEDULED": "تم جدولة نشر هذا المحتوى",
    "REPORT": {
      "ACTION": "تقرير",
      "CODE_OF_ETHICS": "مدونة لقواعد السلوك",
      "CONFIRM": "يُقدِّم",
      "EMPTY_ERROR": "يجب عليك ملء الحقول بشكل صحيح.",
      "FLUICITY_TERMS_PART_A": "تعرف على المزيد حول",
      "FLUICITY_TERMS_PART_B": "و",
      "FLUICITY_TERMS_PART_C": "من الطلاقة.",
      "PLACEHOLDER": "أضف تعليقا لتفاصيل التقرير الخاص بك.",
      "SELECT_REASON": "وضح سبب الإبلاغ عن هذا المحتوى:",
      "SUCCESS": "نشكرك على الإبلاغ عنه. تمكننا من ضمان جودة المحتوى على الطلاقة.",
      "TERMS_OF_USE": " شروط الاستخدام"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {رد} one {رد} other {ردود}}",
    "SAVE": "حفظ",
    "SAVE_THE_DRAFT": "احفظ المسودة",
    "SCHEDULE": "برنامج",
    "SCHEDULED": "المقرر",
    "SCHEDULED_AT": "مجدولة في {date}",
    "SCHEDULED_AT_TOASTER": "تم جدولة نشر هذا المحتوى في {date}",
    "SEE": {
      "COLLABORATIVE_DECISION": "انظر القرارات التعاونية",
      "FOLDER": "انظر المجلد",
      "IDEA": "انظر الاقتراح",
      "IDEAS_REQUEST": "انظر الدعوة لتقديم مقترحات",
      "PARTICIPATORY_BUDGET": "انظر الميزانية التشاركية"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "من <strong>{startAtDate} في {startAtHour}</strong> إلى <strong>{endAtDate} الساعة {endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "اسود و ابيض",
        "DOWNLOAD": "تحميل",
        "GENERATE": "إنشاء رمز الاستجابة السريعة",
        "TITLE": "رمز الاستجابة السريعة"
      },
      "SHARE_IT": "شارك"
    },
    "SORT": {
      "BUTTON": "فرز",
      "POPULAR": "جمع",
      "RECENT": "مؤخرًا"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "توليف المشاركة"
    },
    "STATUS": {
      "FORM_TITLE": "{count, plural, =0 {تغيير الوضع} one {تغيير الوضع} other {تغيير الوضع: {count} مقترحات محددة}}",
      "MODAL": {
        "TITLE": "تقدم الاقتراح"
      },
      "ORIGINAL_POST": {
        "LABEL": "عنوان الاقتراح الأصلي",
        "TITLE": "حدد المنشور الأصلي الذي يرتبط به هذا الاقتراح:"
      },
      "POPOVER": {
        "BUTTON": "اقرأ المزيد عنها"
      },
      "SUBMIT": "تحديث",
      "TITLE": "حالة",
      "UPDATED_SUCCESSFULLY": "تم تحديث الحالة بنجاح."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "متاحون",
        "COMING": "القادم",
        "ENDED": "منتهية",
        "ENDLESS": "مباشر",
        "ONGOING": "جارٍ"
      },
      "TABS": {
        "LABEL": "علامات تبويب اختيار مراحل النشر"
      }
    },
    "SUMMARY": {
      "TITLE": "ملخص الفكرة",
      "TOOLTIP": "تم إنشاء هذا الملخص بمساعدة الذكاء الاصطناعي لمساعدتك على قراءة الفكرة."
    },
    "TAGS": {
      "PERIOD": "من <strong>{startAtDate} في {startAtHour}</strong> إلى <strong>{endAtDate} الساعة {endAtHour}</strong>",
      "PERIOD_SAME_DAY": "<strong>{startAtDate}</strong> من <strong>{startAtHour}</strong> إلى <strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "من <strong>{startAtDate}</strong> إلى <strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "مشكلة",
      "ARTICLE": "مقالة - سلعة",
      "COLLABORATIVE_DECISION": "القرارات التعاونية",
      "DEMAND": "رسالة",
      "EVENT": "حدث",
      "FOLDER": "مجلد",
      "IDEA": "اقتراح",
      "IDEAS_REQUEST": "دعوة لتقديم مقترحات",
      "PARTICIPATORY_BUDGET": "الميزانية التشاركية",
      "STUDY": "استبيان",
      "SURVEY": "استبيان"
    },
    "UPDATED": "تم تحديث المنشور بنجاح."
  },
  "POST_FORM": {
    "ACTION_SAVE": "حفظ",
    "ADMIN_UPDATE_ALERT": "عند تعديل اقتراح ، نرسل تلقائيًا إشعارًا بالبريد الإلكتروني إلى مؤلفه. للتأكد من موافقة المؤلف على التعديل الذي أجريته ، ننصحك بالاتصال به مباشرةً مسبقًا.",
    "APPLICATION_FILE": "استيراد ملف التطبيق التفصيلي الخاص بك",
    "APPLICATION_FILE_BUTTON": "رفع ملف",
    "APPLICATION_FILE_TOOLTIP": "لتقديم اقتراحك ، يجب عليك تحميل ملف التطبيق. للقيام بذلك ، قم بتنزيل وملء النموذج المقدم وتحميله مباشرة أدناه.<br></br><br></br> في حين أن الحقول الأخرى عامة (العنوان والوصف والموضوع وما إلى ذلك) ، فإن محتوى هذا الملف سيكون متاحًا فقط لمسؤولي النظام الأساسي.<br></br><br></br> <b>أنواع الملفات:</b> .pdf ، .doc ، .docx ، .txt ، .odt ، .rtf ، .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "مشاركة مستندات إضافية مثل الصور أو فيديو في أخبارك.",
        "CONSULTATION": "شارك مستندات إضافية مثل قواعدك، صورًا، أو فيديو في استشارتك.",
        "FOLDER": "شارك مستندات إضافية مثل الصور أو مقاطع الفيديو في ملفك."
      },
      "TITLE": "المرفقات"
    },
    "ATTACHMENTS_FILES": "ملفات مرفقة",
    "ATTACHMENTS_IMAGES": "صور مرفقة",
    "ATTACHMENTS_TITLE": "المستندات",
    "AUTHORED_BY": "من الكاتب؟",
    "AUTHORED_BY_A_THIRD_PARTY": "شخص ثالث",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "شخص خارج المنصة",
    "AUTHORED_BY_CUSTOM": "مخصص",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "جمعية، مجموعة من المواطنين، جمعية...",
    "AUTHORED_BY_FIRST_NAME": "الاسم الأول للمؤلفين",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Ahmed : جون",
    "AUTHORED_BY_LAST_NAME": "اسم عائلة المؤلفين",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "مثال: Folani",
    "AUTHORED_BY_MYSELF": "أنا",
    "AUTHORED_BY_MY_SPACE": "منظمتي",
    "BUDGET": "الميزانية",
    "BUDGET_PLACEHOLDER": "حدد الميزانية",
    "CHOOSE_A_FOLDER": "اختر مجلدا",
    "CONTENT": "الوصف",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "نوع المساهمة",
      "CUSTOM_PLACEHOLDER": "تحديد نوع المساهمات التي ترغب في جمعها.",
      "DESCRIPTION": "تخصيص تسمية الزر (CTA) لتقديم المساهمات.",
      "OPTIONS": {
        "CONTRIBUTION": "المساهمة",
        "OTHER": "آخر",
        "PROPOSAL": "اقتراح",
        "QUESTION": "سؤال",
        "REPORT": "تبليغ"
      },
      "PREVIEW": ": معاينة",
      "TITLE": "نوع المساهمة"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "لتشجيع ردود الفعل (التصويت لصالح أو ضد)",
          "NAME": "رف دائري"
        },
        "LIST": {
          "DESCRIPTION": "لعرض موجز لجميع الأفكار",
          "NAME": "قائمة"
        },
        "MAP": {
          "DESCRIPTION": "لعرض جغرافي لجميع الأفكار",
          "NAME": "خريطة"
        }
      },
      "SUBTITLE": "تخصيص صفحة استشارتك من خلال اختيار عرض الأفكار الافتراضي. في كل الأحوال ، سيتمكن الأعضاء من اختيار عرض مختلف.",
      "TITLE": "عرض الأفكار"
    },
    "DESCRIPTION": "الوصف",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "تُتيح لك هذه القسم إيضاح سياق وتحديات الأخبار للمستخدمين.",
        "CONSULTATION": "هذا القسم يتيح لك شرح سياق وتحديات استشارتك للمستخدمين.",
        "FOLDER": "هذا القسم يتيح لك شرح سياق وتحديات ملفك للمستخدمين."
      },
      "TITLE": "وصف الخطوة"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "عرض الصور في قائمة الأطفال",
        "TITLE": "صورة"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "تفعيل التعليقات على استطلاعك"
      },
      "GEOJSON": {
        "DESCRIPTION": "تخصيص الخريطة بمناطق جغرافية ونقاط اهتمام على {link} ثم الصق الكود أدناه.",
        "TITLE": "تخصيص البطاقة"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "تعديل الشذوذ",
        "COMMUNICATION": "تعديل الأخبار",
        "CONSULTATION": "تعديل الاستشارة",
        "DEMAND": "تعديل الرسالة",
        "FOLDER": "تعديل المجلد",
        "IDEA": "تعديل المساهمة"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "لمنح حق الوصول إلى عضو ، يجب أن يكون <i> مساهمًا </ i> في المساحة. فقط <i> المسؤول </ i> يمكنه منح هذا الدور.",
      "SUBTITLE": "قائمة الأعضاء الذين يملكون حق الوصول لإدارة هذه الاستشارة.",
      "TITLE": "المديرين"
    },
    "END_AT": "تاريخ ووقت الانتهاء",
    "ERRORS": {
      "FILL_FIELDS": "يجب عليك ملء الحقول بشكل صحيح.",
      "LOCATION_NOT_IN_THE_LIST": "يجب عليك تحديد عنوان من القائمة."
    },
    "EVENT_URL_LABEL": "حدث الويب",
    "EVENT_URL_PLACEHOLDER": "قدِّم عنوان URL الخاص بالتكبير ، وجيتسي ، والفِرق ، والاجتماع ، وما إلى ذلك.",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "إجابة(إجابات) مسموح بها",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "تحقق من صحة التاريخ الذي أدخله المستخدم مع تاريخ مرجعي.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "اختر مشغلاً",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "حدد كل إجابة ممكنة.",
      "ACCEPTED_ANSWERS_SUMMARY": "الإجابات المسموح بها",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "افصل كل إجابة مسموح بها بسطر جديد.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "الإجابة 1  \nالإجابة 2  \nالإجابة 3  \nالإجابة 4  ",
      "ADD_DESCRIPTION": "إضافة وصف",
      "ADD_QUESTION": "أضف سؤالاً",
      "ADD_SECTION": "إضافة قسم",
      "CONFIDENTIAL": "سرية",
      "CONFIDENTIAL_INFORMATION_NOTICE": "ستكون إجابتك مرئية فقط لمشرفي النظام.",
      "CONFIDENTIAL_QUESTION": "سؤال سري",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "سيتم رؤية الإجابة فقط من قبل المسؤولين والمديرين الذين لديهم الصلاحيات.",
      "DATE_OPERATOR": {
        "EQ": "يكون",
        "GT": "أكبر من",
        "GTE": "أكبر من أو يساوي",
        "LT": "أقل من",
        "LTE": "أقل من أو يساوي",
        "NOT_EQ": "ليس"
      },
      "DEFAULT_FIELD_INFO": "بشكل افتراضي",
      "DESCRIPTION_LABEL": "الوصف",
      "DESCRIPTION_PLACEHOLDER": "هذا السؤال سيساعدنا في معرفتك بشكل أفضل.",
      "DROPDOWN_QUESTION": "قائمة منسدلة",
      "DROPDOWN_QUESTION_DESCRIPTION": "سيتم عرض الخيارات في قائمة منسدلة",
      "MAXLENGTH": "تقييد عدد الأحرف",
      "MAXLENGTH_DESCRIPTION": "حدد الحد الأقصى لعدد الأحرف المسموح به",
      "MAXLENGTH_LABEL": "عدد الأحرف",
      "MAXLENGTH_PLACEHOLDER": "غير محدود",
      "MAXLENGTH_SUMMARY": "أقصى عدد من الحروف",
      "OPTIONS": {
        "ADD_OPTION": "إضافة خيار",
        "ADD_OTHER": "إضافة \"غير ذلك\"",
        "OR": "أو",
        "OTHER": "غير ذلك"
      },
      "OPTION_LABEL": "الخيار {index}",
      "PLACEHOLDER": "إجابتك",
      "QUESTION_LINKS": {
        "DESCRIPTION": "إظهار إذا كانت الإجابة على ...",
        "OPERATOR": {
          "BLANK": "فارغ",
          "CONTAINS": "يحتوي",
          "EQ": "هو",
          "GT": "أكبر من",
          "GTE": "أكبر من أو يساوي",
          "LT": "أقل من",
          "LTE": "أقل من أو يساوي",
          "NOT_CONTAINS": "لا يحتوي على",
          "NOT_EQ": "ليس",
          "PRESENT": "غير فارغ"
        },
        "OPERATOR_LABEL": "مشغل",
        "OPTIONS_LABEL": "خيارات",
        "QUESTION_LABEL": "سؤال",
        "TITLE": "عرض السؤال"
      },
      "QUESTION_LINKS_SUMMARY": "شرط العرض",
      "REQUIRED": "إلزامي",
      "REQUIRED_QUESTION": "سؤال إلزامي",
      "SUBMIT_FORM": "أرسل النموذج",
      "SURVEY_DESCRIPTION_1": "الاستبيان يتوافق مع الأسئلة التي ترغب في طرحها على مستخدميك.",
      "SURVEY_DESCRIPTION_2": "قم بتكوين الاستبيان بناءً على استشارتك.",
      "SURVEY_TITLE": "الاستبيان",
      "TITLE_LABEL": "سؤال",
      "TITLE_PLACEHOLDER": "مثال: ما هو عمرك؟",
      "TYPES": {
        "ATTACHMENT": "مرفقات",
        "CHECKBOX": "ردود متعددة",
        "DATE": "تاريخ",
        "LOCATION": "التوطين",
        "MONEY": "ميزانية",
        "PHONE_NUMBER": "رقم الهاتف",
        "PICTURE": "صورة الغلاف",
        "RADIO": "إجابة فردية",
        "SECTION": "القسم",
        "TEXT": "إجابة قصيرة",
        "TEXTAREA": "فقرة",
        "TITLE": "نوع الحقل"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "لقد جمعت بالفعل إجابات على هذا السؤال.",
        "DESCRIPTION_2": "إذا قمت بتعديلها، ستُمسح الردود المرتبطة نهائيًا.",
        "DESCRIPTION_3": "هل تحتاج إلى هذه البيانات؟ قم بتصدير إجاباتك قبل حذف هذه الأسئلة و/أو الخيارات.",
        "TITLE": "أنت متأكد؟"
      }
    },
    "GENERAL_INFO": "معلومات عامة",
    "IMAGE": "صورة",
    "LOCALISATION_LABEL": "الموقع أو العنوان",
    "LOCALISATION_MARKER_PLACED": "علامة موضوعة",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "صافي",
    "LOCALISATION_MODAL_NOTICE_TEXT": "انقر على الخريطة لتحديد الموقع.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "يتأكد",
    "LOCALISATION_MODAL_TITLE": "أضف موقعًا",
    "LOCALISATION_NO_RESULTS": "الرجاء الكتابة للحصول على اقتراحات",
    "LOCALISATION_PLACEHOLDER": "أضف موقعًا",
    "LOCALISATION_SEE_MAP": "إعرض الخريطة",
    "MODERATABLE": {
      "LABEL": "التدقيق قبل النشر",
      "TOOLTIP": "جميع المساهمات يجب أن تتم موافقة عليها من قبل المسؤول ليتم نشرها وظهورها لباقي المستخدمين."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "قم بصياغة وصف يحدد الانحراف الذي تمت مواجهته وطبيعته. ضعها في سياقها من أجل تسهيل علاجها.",
        "MODAL_DESCRIPTION": "سوف يقوم {spaceName} بالرد عليك في أقرب وقت ممكن.",
        "MODAL_TITLE": "تهانينا ، تم إرسال الحالة الشاذة!",
        "SIDEBAR_ACTION": "إرسال",
        "SIDEBAR_DESCRIPTION": "المنظمة هنا للاستماع وسترد في أقرب وقت ممكن.",
        "TITLE": "الإبلاغ عن حالة شاذة",
        "TITLE_PLACEHOLDER": "أود الإشارة ..."
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "قدم موضوعًا موضوعيًا أو سلط الضوء على مبادرة من أجل توفير معلومات منتظمة عن التدابير الجديدة ونشر المعلومات التربوية.",
        "MODAL_DESCRIPTION": "ها هو الآن مرئي من قبل المستخدمين الآخرين في هذا الفضاء. {isPrivateSpace, select, true {} other {شاركه على وسائل التواصل الاجتماعي لزيادة انتشاره.}}",
        "MODAL_TITLE": "تهانينا ، تم نشر المقال!",
        "PROBLEMATIC_PLACEHOLDER": "صف في جملة واحدة مقالتك لإثارة الرغبة في قراءته",
        "TITLE": "قم بإنشاء مقال",
        "TITLE_PLACEHOLDER": "اكتب عنوانًا يروق للأعضاء."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "قدم تفاصيل عن خلفية هذه القرارات التعاونية. اشرح طرق المشاركة حتى يتمكن الأعضاء من المشاركة بشكل هادف في البحث عن حلول.",
        "MODAL_DESCRIPTION": "إنه الآن مرئي للمستخدمين الآخرين. اثبته على صفحتك الرئيسية لزيادة الرؤية.",
        "MODAL_TITLE": "مبروك ، تم نشر القرارات التعاونية!",
        "PROBLEMATIC_PLACEHOLDER": "أثرِ في رغبة المستخدمين في المشاركة في جملة واحدة.",
        "SIDEBAR_ACTION": "نشر",
        "TITLE": "إنشاء قرارات تعاونية",
        "TITLE_PLACEHOLDER": "اكتب عنوانًا يروق للأعضاء."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "وضّح سياق الرسالة بذكر أي عنصر يساعد في فهم موضوعك بشكل أفضل.",
        "MODAL_CTA": "عرض رسائلي",
        "MODAL_DESCRIPTION": "سيتلقى المستلم إشعارًا في أقرب وقت ممكن. يمكنك في أي وقت العثور على هذه الرسالة في قائمة \"رسائلي والمشكلات\" في ملفك الشخصي.",
        "MODAL_TITLE": "تهانينا ، تم إرسال الرسالة!",
        "SIDEBAR_ACTION": "إرسال",
        "SIDEBAR_DESCRIPTION": "هذه الرسالة خاصة. يمكن فقط للعضو والمسؤولين رؤيته.",
        "TITLE": "ارسل رسالة",
        "TITLE_PLACEHOLDER": "أود الحصول على معلومات عن"
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "يسمح لك هذا القسم بشرح كيف يمكن للأعضاء حضور الحدث الخاص بك: التاريخ والموقع (العنوان و / أو الارتباط باجتماع عبر الإنترنت).",
          "TITLE": "كيف تحضر"
        },
        "DESCRIPTION_PLACEHOLDER": "قدم سياق الحدث وأبلغ الأعضاء بشروط الوصول إلى هناك.",
        "MODAL_DESCRIPTION": "هو الآن مرئي للأعضاء الآخرين. شاركها على الشبكات الاجتماعية لمنحها رؤية أكثر.",
        "MODAL_TITLE": "تهانينا ، تم نشر الحدث!",
        "PROBLEMATIC_PLACEHOLDER": "صف بالجملة حدثك لإثارة رغبة الآخرين في قراءته",
        "SIDEBAR_ACTION": "نشر",
        "TITLE_PLACEHOLDER": "اكتب عنوانًا يروق للأعضاء."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "قدم تفاصيل عن سياق هذا المجلد. اشرح أشكال المشاركة حتى يتمكن الأعضاء من المشاركة بشكل هادف في البحث عن حلول.",
        "MODAL_DESCRIPTION": "إنه الآن مرئي للمستخدمين الآخرين. اثبته على صفحتك الرئيسية لزيادة الرؤية.",
        "MODAL_TITLE": "تهانينا ، تم نشر المجلد!",
        "PROBLEMATIC_PLACEHOLDER": "إضافة عبارة ملهمة حول ملفك.",
        "SIDEBAR_ACTION": "نشر",
        "TITLE_PLACEHOLDER": "اكتب عنوانًا يروق للأعضاء."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "اشرح اقتراحك وكيف يعمل.",
        "MODAL_CTA": "مشاهدة مساهماتي",
        "MODAL_DESCRIPTION": "اعثر على جميع مساهماتك في ملفك الشخصي.",
        "MODAL_DESCRIPTION_GUEST": "لمتابعة تطوره وتلقي التحديثات، قم بإنشاء حساب. بدون تسجيل، لن تتمكن من رؤية تأثيره أو تلقي إشعارات حول الأصوات والتعليقات.",
        "MODAL_TITLE": "شكرًا لمشاركتك",
        "REDIRECT": "يبدو أن هذا الارتباط لا يعمل. ابحث عن الاستشارة في القائمة لإنشاء اقتراح جديد.",
        "TITLE": "ملء النموذج",
        "TITLE_PLACEHOLDER": "نستطيع…",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "ينشر",
          "SIDEBAR_DESCRIPTION": "بمجرد نشرها، سيتمكن المستخدمون الآخرون من إثراء مساهمتك من خلال تقديم اقتراحات لك."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "مقدمة",
          "SIDEBAR_DESCRIPTION": "ستتم نشر المساهمة بعد التحقق منها من قبل الخدمات."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "قدم تفاصيل عن خلفية هذه الدعوة لتقديم مقترحات المشاريع. اشرح طرق المشاركة حتى يتمكن الأعضاء من المشاركة بشكل هادف في البحث عن حلول.",
        "MODAL_DESCRIPTION": "إنه الآن مرئي للمستخدمين الآخرين. اثبته على صفحتك الرئيسية لزيادة الرؤية.",
        "MODAL_TITLE": "تهانينا ، تم نشر دعوة تقديم العروض!",
        "PROBLEMATIC_PLACEHOLDER": "أثرِ إقبال المستخدمين على المشاركة بجملة.",
        "SIDEBAR_ACTION": "نشر",
        "TITLE_PLACEHOLDER": "اكتب عنوانًا يروق للأعضاء."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "قدم تفاصيل عن خلفية هذه الميزانية التشاركية. اشرح طرق المشاركة حتى يتمكن الأعضاء من المشاركة بشكل هادف في البحث عن حلول.",
        "MODAL_DESCRIPTION": "إنه الآن مرئي للمستخدمين الآخرين. اثبته على صفحتك الرئيسية لزيادة الرؤية.",
        "MODAL_TITLE": "تهانينا ، تم نشر الميزانية التشاركية!",
        "PROBLEMATIC_PLACEHOLDER": "ألهم المستخدمين للمشاركة بجملة واحدة.",
        "SIDEBAR_ACTION": "نشر",
        "TITLE_PLACEHOLDER": "اكتب عنوانًا يروق للأعضاء."
      },
      "STUDIES": {
        "DESCRIPTION": "الاستبيان يشير إلى النموذج الذي تم إنشاؤه خارج المنصة على Typeform، Google Form، Survey Monkey، Tally أو أي منصة أخرى تسمح بإنشاء النماذج.",
        "DESCRIPTION_PLACEHOLDER": "أعط تفاصيل حول سياق هذا الاستشارة وطرق المشاركة فيها.",
        "FORM_DESCRIPTION": "إضافة روابط الاستبيان الخاص بك لمشاركته على منصتك.",
        "MODAL_DESCRIPTION": "هو الآن مرئي للأعضاء الآخرين. شاركها على الشبكات الاجتماعية لمنحها رؤية أكثر.",
        "MODAL_TITLE": "تهانينا ، تم نشر الدراسة!",
        "PROBLEMATIC_PLACEHOLDER": "أثري رغبة المستخدمين في المشاركة في جملة واحدة.",
        "SIDEBAR_ACTION": "نشر",
        "STUDY_ID_PLACEHOLDER": "مثال: https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "مثال: https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "رابط النتائج",
        "STUDY_TITLE": "رابط الاستطلاع",
        "TITLE_PLACEHOLDER": "اكتب عنوانًا يروق للأعضاء."
      },
      "TITLE": {
        "ANOMALY": "إنشاء خلل",
        "COMMUNICATION": "إنشاء خبر",
        "CONSULTATION": "إنشاء استشارة",
        "DEMAND": "إنشاء رسالة",
        "FOLDER": "إنشاء مجلد",
        "IDEA": "إنشاء مساهمة"
      }
    },
    "POST_PUBLISHED": "تم نشر هذا المحتوى الآن.",
    "POST_PUBLISHED_AT": "تم النشر في {date} الساعة {time}",
    "POST_SAVED": "هذا المحتوى محفوظ الآن.",
    "POST_SCHEDULED": "تمت جدولة هذا المحتوى في {date} في {time}.",
    "PROBLEMATIC": "عبارة قبض",
    "PUBLICATION_CANCELLED": "تم بالفعل إلغاء المنشور.",
    "SIMILAR_PROPOSALS": "اقترح أعضاء آخرون مقترحات مماثلة:",
    "START_AT": "تاريخ ووقت البدء",
    "STEPS": {
      "CONFIGURATION": "تكوين المرحلة",
      "DESCRIPTION": "يسمح لك هذا القسم بإبلاغ الأعضاء بالمواعيد الرئيسية للاستشارة.",
      "DESCRIPTION_TABS": "علامات التبويب وصف متعدد اللغات الخطوة",
      "END_AT_HELPER_TEXT": "اختياري للخطوات المستمرة",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "فكر في إضافة \"رابط النتائج\" والتحقق من التكوين لتمكين الخيار.",
        "ADMIN_ONLY_TEXT": "عرض نتائج الاستشارة",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "يحتوي التقرير الكامل على بيانات أولية لكل سؤال. هذا عنصر مهم للشفافية تجاه الأعضاء.",
          "ADMIN_ONLY_TEXT": "عرض نتائج الاستشارة"
        }
      },
      "PLACEHOLDER": "اشرح كيف تعمل هذه الخطوة.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "يمكن لجميع الأعضاء نشر مقترحات جديدة في الاستشارة. في حالة التعطيل ، سيتمكن المسؤولون فقط من إنشاء عروض جديدة.",
        "ADMIN_ONLY_TEXT": "التقديم مفتوح للأعضاء"
      },
      "TITLE": "جدول التكوين"
    },
    "TITLE": "عنوان",
    "UNDERSTOOD": "فهمت!",
    "VIDEO": "فيديو",
    "VIDEO_HELPER": "يمكنك فقط مشاركة رابط Youtube أو Vimeo.",
    "VIDEO_LABEL": "ارتباط بالفيديو",
    "VIDEO_PLACEHOLDER": "مثال: http://www.youtube.com/watch؟=id أو http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "تقييد الأصوات (لصالح) على ميزانية {count} المحددة مسبقًا",
        "TITLE": "تقييد الميزانية"
      },
      "MIN_MAX": {
        "MAX_LABEL": "الحد الأقصى لعدد الأصوات",
        "MIN_LABEL": "الحد الأدنى لعدد الأصوات",
        "TITLE": "عدد الدعم المخصص"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "سيتمكن المستخدمون من دعم المساهمات حتى استنفاد الحصة الإجمالية. يجب تقدير ميزانية المساهمات.",
          "NAME": "بالظرف"
        },
        "DOUBLE": {
          "DESCRIPTION": "سيتمكن المستخدمون من دعم المقترحات بشكل إيجابي أو سلبي. يتم استخدام هذا الخيار في كثير من الأحيان للاستفسار عن المقترحات أو الحصول على ملاحظات.",
          "NAME": "مؤيد أو معارض"
        },
        "SINGLE": {
          "DESCRIPTION": "سيتمكن المستخدمون من دعم المقترحات بشكل إيجابي فقط. يتم استخدام هذا الخيار في كثير من الأحيان إذا كانت استشارتك تتضمن مرحلة التصويت.",
          "NAME": "مؤيد"
        },
        "SUBTITLE_1": "تتيح طرق التصويت للمستخدمين دعم المساهمات التي تم إجراؤها في استطلاعك.",
        "SUBTITLE_2": "قم بضبط الشروط وفقًا لمشروعك",
        "TITLE": "خيارات التصويت"
      },
      "UNLIMITED": "عدد غير محدود"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "التحليل",
      "CONTRIBUTION": "المشاركة",
      "IMPLEMENTATION": "النتائج",
      "SUBMISSION": "التقديم",
      "VOTE": "التصويت"
    },
    "STUDY": {
      "IMPLEMENTATION": "نتائج",
      "SUBMISSION": "إجابه"
    }
  },
  "PREVIOUS": "سابق",
  "PROFILE": {
    "ADDRESS": "العنوان",
    "BIRTHDATE": "تاريخ الميلاد",
    "CROSS_SPACES_WARNING": "المعلومات الواردة أدناه تتعلق بجميع المساحات التي انضممت إليها.",
    "FIRST_NAME": "الاسم الاول",
    "LAST_NAME": "اللقب",
    "NAME_IS_PRIVATE": "سيرى الأعضاء الآخرون أنك: {displayName}",
    "NATIONAL_ID": "رقم الهوية الوطنية",
    "PRIVATE_INFORMATION_NOTICE": "سيتم استخدام هذه المعلومات فقط للأغراض الإحصائية المتعلقة بالمشاركة.",
    "PROFILE_UPDATED": "تحديث الملف الشخصي.",
    "SEX": "الجنس",
    "SEX_FEMALE": "أنثى",
    "SEX_HELPER": "كما هو موضح على بطاقة الهوية الوطنية الخاصة بك. يتم مقارنة هذه البيانات، بمجرد تجميعها، بالإحصاءات المقدمة من قبل المعاهد الوطنية أو من قبل المؤسسة نفسها.",
    "SEX_MALE": "ذكر",
    "SEX_UNSPECIFIED": "غير محدد",
    "SOCIOPROFESSIONAL_CATEGORY": "فئة المهنيين الاجتماعيين",
    "TITLE": "حسابي"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "قبل نشر هذا المحتوى، يجب عليك {link} إلى النموذج",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "إضافة أسئلة",
    "PARENT_WARNING": "قبل أن تتمكن من نشر هذا المحتوى ، يجب عليك نشر {link}.",
    "PUBLISH": {
      "BUTTON": "نشر الآن",
      "CONTENT": "هل ترغب حقًا في النشر؟",
      "NO": "لا",
      "TOAST": "تم نشر هذا المحتوى.",
      "YES": "نعم، نشر"
    },
    "SCHEDULE": {
      "BUTTON": "تخطيط النشر",
      "CONTENT": "هل ترغب حقًا في التخطيط؟",
      "NO": "لا",
      "TOAST": "تم تخطيط هذا المحتوى.",
      "YES": "نعم، قم بالتخطيط"
    },
    "UNPUBLISH": {
      "BUTTON": "إلغاء النشر",
      "CHILDREN_WARNING": "بإلغاء نشر هذا المحتوى، سيتم إلغاء نشر كل ما يحتويه أيضًا ({childrenCount}).",
      "CONTENT": "هل ترغب حقًا في إلغاء النشر؟",
      "NO": "نعم",
      "TOAST": "تم إزالة هذا المحتوى.",
      "YES": "نعم ، إلغاء النشر"
    },
    "UNSCHEDULE": {
      "BUTTON": "إلغاء الجدولة",
      "CONTENT": "هل ترغب حقًا في إلغاء الجدولة؟",
      "NO": "نعم",
      "TOAST": "تم إلغاء جدولة هذا المحتوى.",
      "YES": "نعم، إلغاء الجدولة"
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {لا يوجد إجابة} one {{count} إجابة} other {{count} إجابات}}"
    }
  },
  "SEARCH": {
    "BUTTON": "بحث",
    "CATEGORIES_PLACEHOLDER": "تصفية حسب الموضوع",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "ابدأ في كتابة الكلمات الرئيسية في شريط البحث.",
      "NO_RESULTS": "تأكد من كتابة كل شيء بشكل صحيح. يمكنك أيضًا محاولة تقصير البحث أو إعادة صياغته."
    },
    "INPUT_PLACEHOLDER": "بحث",
    "RESULTS_COUNT": "{count, plural, =0 {لا توجد نتائج} one {نتيجة واحدة} other {{count} نتيجة}}",
    "TYPES_PLACEHOLDER": "تصفية حسب نوع المحتوى"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "العودة إلى الاستشارة",
    "BIRTHDATE": {
      "TITLE": "تاريخ الميلاد"
    },
    "CSAM": {
      "TITLE": "تسجيل الدخول إلى CSAM"
    },
    "CTA": "المشاركة",
    "DESCRIPTION": "<b>هذه الاستشارة آمنة.</b> للوصول إليها، يجب عليك تأكيد البيانات المذكورة أدناه وتعبئة البيانات الناقصة.<conditional> في أي وقت، يمكنك ممارسة حقوقك في الوصول، والتصحيح، والحذف لهذه البيانات عن طريق الاتصال بـ dpo@flui.city.</conditional>",
    "DIMENSIONS": {
      "ERROR": "لسوء الحظ ، المعلومات التي حددتها لا تسمح لك بالمشاركة في الاستشارة. قم بتصحيح بياناتك أو العودة إلى الاستشارة.",
      "TITLE": "أبعاد"
    },
    "INLINE_DESCRIPTION": "<b>هذا الاستشارة آمنة.</b> للوصول إليها ، يجب عليك تقديم البيانات اللازمة. في أي وقت ، يمكنك ممارسة حقوق الوصول والتصحيح والحذف لهذه البيانات عبر صفحة ملفك الشخصي إذا كان لديك حساب أو عبر البريد الإلكتروني عبر dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "يجب إدخال رقم تسجيل صالح يحتوي على 11 رقمًا.",
      "TITLE": "الهوية الوطنية البلجيكية"
    },
    "PENDING_VERIFICATION_TOOLTIP": "سيتم احتساب مشاركتك فقط بعد التحقق من مستنداتك.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "الوجه الخلفي (للبطاقة الهوية الجديدة فقط)",
      "FORM": {
        "DESCRIPTION": "يرجى توفير الوجه الأمامي والخلفي لبطاقة الهوية الخاصة بك (بتنسيق JPEG، JPG، PNG، HEIC، WEBP، أو PDF، الحجم الأقصى الموصى به 2 ميغابايت).<br></br>يتم قبول:<ul><li>البطاقة الوطنية للهوية</li><li>الجواز الفرنسي</li><li>رخصة القيادة (بتنسيق البطاقة الائتمانية الجديدة)</li></ul>",
        "GENERIC_ERROR": "حدث خطأ أثناء تحميل مستنداتك. يرجى التحقق من حالة الاتصال بالإنترنت الخاص بك أو إعادة المحاولة لاحقًا. يمكنك أيضًا المحاولة باختصار حجم المستند (الحجم الأقصى الموصى به 2 ميغابايت).",
        "SUCCESS_TOAST": "تم التحقق من هويتك بنجاح."
      },
      "FRONT": "الوجه الأمامي",
      "NO": "لا",
      "TITLE": "وثيقة الهوية",
      "YES": "نعم"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "يتم قبول فقط: <ul><li>فاتورة كهرباء أو غاز أو ماء حديثة</li><li>فاتورة هاتف ثابت أو محمول</li><li>كشف راتب</li><li>شهادة تأمين السكن (حريق، مخاطر الإيجار أو المسؤولية المدنية)</li><li>بطاقة انتخابية</li><li>إشعار ضريبي</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "يجب عليك التحقق من هويتك أولاً لإرسال إثبات عنوانك.",
      "DESCRIPTION": "يرجى تقديم إثبات الإقامة (بتنسيق JPEG ، JPG ، PNG ، HEIC ، WEBP أو PDF ، والحجم الموصى به حتى 2 ميغابايت).",
      "DOCUMENT_CONFIRMATION": "بعد التحقق من قبل فريقنا، سيتم إرسال بريد إلكتروني لتأكيد مشاركتك",
      "TITLE": "تأييد العنوان"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "هذه القيمة غير صحيحة."
    },
    "SIGNUP_INVITATION": "إذا كنت ترغب في <b>تلقي رسالة تأكيد بالبريد الإلكتروني</b> لمشاركتك وحفظ مستنداتك، يرجى إنشاء حساب.",
    "SUCCESS": "يمكنك الآن المشاركة في الاستشارة.",
    "TOOLTIP": "هذه الاستشارة آمنة وتتطلب معلومات معينة للمشاركة.",
    "VALIDATED_INLINE_DESCRIPTION": "لقد تحققنا من هويتك كـ <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "التحقق من الحساب"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "عرض أسئلة الأمان",
    "FORM_BUILDER": {
      "DESCRIPTION": "أسئلة الأمان هي آليات التحكم في الوصول.<br></br> تسمح بالتحقق من أن المشاركين يستوفون شروطًا معينة قبل المساهمة أو التصويت أو التعليق أو الرد على استبيان (على سبيل المثال: رمز الوصول، الهوية الوطنية، المقيم في إقليم، إلخ.).",
      "TITLE": "أسئلة الأمان"
    },
    "OPTION_1": {
      "DESCRIPTION": "ليس هناك حاجة للتسجيل للمشاركة",
      "TITLE": "الجميع"
    },
    "OPTION_2": {
      "DESCRIPTION": "يجب على المستخدمين التسجيل للمشاركة",
      "TITLE": "المسجلين"
    },
    "OPTION_3": {
      "DESCRIPTION": "يجب على المستخدمين التحقق من حساباتهم للمشاركة.",
      "TITLE": "المسجلون المؤكدون"
    },
    "OPTION_4": {
      "DESCRIPTION": "المستودع مغلق للمستخدمين",
      "TITLE": "المسؤولون"
    },
    "WHO_CAN_COMMENT": "من يمكنه التعليق؟",
    "WHO_CAN_RESPOND_SURVEY": "من يمكنه الإجابة على الاستبيان؟",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "من يمكنه تقديم مساهمة؟",
    "WHO_CAN_VOTE": "من يمكنه التصويت؟"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "إعدادات تسجيل الدخول",
      "DATA_SHARED_WITH_SPACE": "بياناتي",
      "LANGUAGE": "لغة",
      "PASSWORD": "كلمة المرور (12 أحرف كحد أدنى)",
      "VERIFIED": "يفحص",
      "VERIFIED_EMAIL": "البريد الإلكتروني المُوَثَّق"
    },
    "COOKIES": {
      "DESCRIPTION": "تسمح ملفات تعريف الارتباط 'الوظيفية' هذه بتنشيط إمكانيات محددة على Fluicity Engage من أجل تحسين تجربة العضو الخاصة بك.",
      "FACEBOOK": {
        "DESCRIPTION": "يسمح لك بتسجيل الدخول إلى مساحة المشاركة الخاصة بك باستخدام بيانات اعتماد Facebook الخاصة بك.",
        "TITLE": "الفيسبوك اتصال"
      },
      "GOOGLE": {
        "DESCRIPTION": "يسمح لك بتسجيل الدخول إلى مساحة المشاركة الخاصة بك باستخدام بيانات اعتماد Google الخاصة بك.",
        "TITLE": "جوجل تسجيل الدخول"
      },
      "TITLE": "الإعدادات المتعلقة بملفات تعريف الارتباط الخاصة بي",
      "VIMEO": {
        "DESCRIPTION": "يسمح لك بمشاهدة مقاطع فيديو Vimeo المضمنة في مساحة المشاركة.",
        "TITLE": "فيميو"
      },
      "YOUTUBE": {
        "DESCRIPTION": "يسمح لك بمشاهدة مقاطع فيديو Youtube المضمنة في مساحة المشاركة.",
        "TITLE": "موقع يوتيوب"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "نعم ، احذف حسابي",
      "CTA": "احذف حسابي",
      "TITLE": "هل تريد حقًا حذف حساب Fluicity Engage الخاص بك؟"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "للاشتراك مرة أخرى ، أو إلغاء الاشتراك من نوع واحد أو أكثر من الإشعارات ، استخدم الإعدادات أدناه. يمكنك الوصول إلى هذه المعلمات متى شئت من إعدادات حسابك.",
        "SUCCESS_TITLE": "لقد نجحت في إلغاء الاشتراك من هذا النوع من الإخطارات."
      }
    },
    "JOIN_SPACE": "الانضمام إلى {spaceName}",
    "LANGUAGE": {
      "LABEL": "لغة"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "نعم ، اترك مساحة",
      "CTA": "مغادرة {spaceName}",
      "DESCRIPTION": "بمغادرة هذه المساحة ، لن تتلقى بعد الآن إخطارات تتعلق بمشاوراتها وأخبارها ولن تتمكن بعد الآن من إنشاء مقترحات جديدة والتعليق والتصويت وما إلى ذلك.",
      "TITLE": "هل تريد حقًا مغادرة {spaceName}؟"
    },
    "NO_SPACES": "أنت لا تتابع أي مساحة.",
    "PASSWORD": {
      "CONFIRMATION": "تأكيد كلمة المرور",
      "CREATE": "خلق",
      "CREATE_INPUT": "إنشاء كلمة مرور",
      "CREATE_MESSAGE": "لم تقم بتعيين كلمة مرور حتى الآن",
      "CURRENT": "كلمة المرور الحالية",
      "DIALOG": {
        "CREATE_TITLE": "إنشاء كلمة مرور",
        "SUBTITLE_2": "الرجاء إدخال كلمة المرور الحالية وكلمة المرور الجديدة:",
        "TITLE": "تغيير كلمة المرور الخاصة بي",
        "VALIDATE": "يتأكد"
      },
      "ERROR_LOGIN": "خطأ في تسجيل الدخول.",
      "FORGOT_PASSWORD": "هل نسيت كلمة المرور؟",
      "NEW": "كلمة السر الجديدة",
      "PLACEHOLDER": "كلمة المرور",
      "SHORT_PASSWORD": "لا يمكن أن يكون طول كلمة المرور أقل من {length}",
      "SUCCESS": "تم حفظ كلمة المرور الخاصة بك.",
      "UPDATE": "تحديث",
      "WRONG_PASSWORD": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "طلب الوصول إلى بياناتي الشخصية",
        "EMAIL_BODY": "مرحبًا،\n\nوفقًا لسياسة خصوصية البيانات الشخصية لحل Fluicity Engage ، أود أن أتلقى تصديرًا لجميع البيانات الشخصية المرفقة بحسابي ({userEmail}) المستضافة على النظام الأساسي.\n\nمع أطيب التحيات،\n\n{userName}",
        "EMAIL_SUBJECT": "طلب نقل البيانات"
      },
      "TITLE": "الخصوصية والبيانات الشخصية"
    },
    "REQUIRED_DIMENSION_INFO": "مطلوب معلومات معينة للمشاركة في هذا الفضاء. لممارسة حقك في المسح ، ما عليك سوى الخروج من المساحة.",
    "SPACE_SELECTION": "اختيار الفضاء",
    "TABS": {
      "INFO": "تفاصيلي",
      "MY_SPACE": "فضائي",
      "NOTIFICATIONS": "الإشعارات الخاصة بي",
      "SETTINGS": "اعداداتي"
    }
  },
  "SIGN_IN": "انضم",
  "SIGN_OUT": "خروج",
  "SIGN_UP": {
    "EMAIL": "البريد الإلكتروني",
    "LOCATION_LABEL": "مكان الإقامة",
    "LOCATION_PLACEHOLDER": "مثال: لندن",
    "PRIVACY": "سياسة الخصوصية",
    "TERMS": "شروط الاستخدام"
  },
  "SORT": {
    "COMMENTED": "الأكثر تعليقًا",
    "LEAST_EXPENSIVE": "الأقل تكلفة",
    "POPULAR": "الاكثر شهرة",
    "RANDOM": "عشوائي",
    "RECENT": "الأحدث",
    "UPVOTED": "الأكثر تصويتا"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {استشارة بدأت} one {استشارة بدأت} other {استشارات بدأت}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {مساهمة مُنجَزَة} one {مساهمة مُنجَزَة} other {مساهمات مُنجَزَة}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {مشاركة} one {مشاركة} other {مشاركات}}",
        "SUBSCRIBED_CITIZENS": "{count , plural, =0 {لا يوجد عضو} one {عضو مسجل} other {أعضاء مسجلون}}"
      },
      "TITLE": "عام"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "ستجد هنا المشاريع ودعوات تقديم المقترحات والميزانيات التشاركية والدراسات التي نشرتها المنظمة.",
      "TITLE": "{count, plural, =0 {لا توجد استشارات} one {استشارة واحدة} other {{count} استشارات}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "ستجد هنا رسائلك ومشاكلك.",
        "TITLE": "رسائلي ومشاكلي "
      },
      "PROPOSALS": {
        "EMPTY_STATE": "هنا سوف تجد مقترحاتك.",
        "TITLE": "مقترحاتي"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "تبوك",
      "ADDRESS_PLACEHOLDER": "ابحث عن عنوان",
      "ADMINISTRATORS": "المسؤولين",
      "BRAND_LOGO_LABEL": "شعار الفضاء",
      "BRAND_LOGO_TOOLTIP": "سيظهر شعار الفضاء في الجزء العلوي الأيسر من النظام الأساسي ، في التنقل وفي رسائل البريد الإلكتروني.",
      "COLOR_LABEL": "اللون",
      "COLOR_PLACEHOLDER": "اللون",
      "DECISION_MAKER_FIRST_NAME_LABEL": "الاسم الأول للراعي",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "عيّن الاسم الأول",
      "DECISION_MAKER_LAST_NAME_LABEL": "الاسم الأخير للراعي",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "عيّن الاسم الأخير",
      "DECISION_MAKER_PICTURE_LABEL": "صورة الملف الشخصي للراعي",
      "DECISION_MAKER_ROLE_LABEL": "دور الراعي",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "اكتب دور الراعي في مؤسستك",
      "DESCRIPTION_HELPER": "ويسمح الوصف الوصفي لعلامة meta لمحركات البحث بالحصول على نظرة عامة على محتوى الصفحات المعروضة أثناء البحث.",
      "DESCRIPTION_LABEL": "وصف الوسم",
      "DESCRIPTION_PLACEHOLDER": "قدم نصًا قصيرًا وجذابًا للترحيب والمشاركة",
      "EMAIL_LABEL": "البريد الإلكتروني",
      "EMAIL_PLACEHOLDER": "email@mywebsite.com",
      "FACEBOOK_URL_LABEL": "فيسبوك",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/mypage",
      "FAVICON_LABEL": "فافيكون",
      "FAVICON_TOOLTIP": "الأيقونة المفضلة هي أيقونة صغيرة في علامات تبويب المتصفح أعلى الشاشة.",
      "INSTAGRAM_URL_LABEL": "انستغرام",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/mypage",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "العنوان: 210 شارع جان جوريس، 69007 ليون، فرنسا",
        "COMPANY_EMAIL": "البريد الإلكتروني : info@flui.city",
        "COMPANY_NAME": "إفاليا",
        "COMPANY_PHONE": "هاتف: +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "الموقع مستضاف بواسطة: Amazon Web Services (AWS) في باريس، فرنسا",
        "HOSTING": "الإقامة",
        "HOSTING_AND_TECHNICAL_SOLUTION": "الإقامة والحل التقني",
        "HOST_ADDRESS": "عنوان المضيف: ٣٨ شارع جون ف. كينيدي، L-١٨٥٥ لوكسمبورغ",
        "PLATFORM_HOSTED_BY": "يتم استضافة وتشغيل المنصة بواسطة Fluicity Engage، وهي حل مقدم من قبل شركة Fluicity.",
        "THIRD_PARTY_TRUST": "تعمل Fluicity Engage كطرف ثالث موثوق لجمع ومعالجة البيانات، مع الالتزام بـ RGPD."
      },
      "LINKEDIN_URL_LABEL": "ينكدين",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/mypage",
      "LOCALES": "اللغات",
      "LOCALES_HELPER": "تحديد اللغات التي يمكن للمستخدمين التنقل بها على منصتكم.",
      "LOCALES_LABEL": "اللغات المتاحة",
      "LOCALE_DEFAULT_HELPER": "حدد اللغة الأساسية لمنصتك.",
      "LOCALE_DEFAULT_LABEL": "اللغة اللغة الأساسية",
      "LOGO_PICTURE_LABEL": "صورة الملف الشخصي للمسؤولين",
      "LOGO_PICTURE_TOOLTIP": "عندما ينشئون استشارة أو اقتراحًا أو رسالة أو يرسلون تعليقًا ، سيظهر المسؤولون بهذه الصورة واسم المساحة بدلاً من صورة ملفهم الشخصي واسمهم.",
      "NAME_HELPER": "سيتم عرض اسم المساحة في العديد من الأماكن: باسم الصفحات ، في رسائل البريد الإلكتروني ، بدلاً من اسم المسؤولين ، إلخ.",
      "NAME_LABEL": "اسم الفضاء",
      "NAME_PLACEHOLDER": "حدد اسم الفضاء",
      "PHONE_LABEL": "هاتف",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "لون أصلي",
      "PRIMARY_COLOR_PLACEHOLDER": "لون أصلي",
      "SECONDARY_COLOR_LABEL": "اللون الثانوي",
      "SECONDARY_COLOR_PLACEHOLDER": "اللون الثانوي",
      "SPACE_DECISION_MAKER": "كفيل",
      "SPACE_DECISION_MAKER_TOOLTIP": "الراعي هو شخص من مؤسستك يقوم بإشراك الأعضاء وتحفيزهم.",
      "SPACE_LEGAL_NOTICE": "إشعارات قانونية",
      "SPACE_LEGAL_NOTICE_LABEL": "وصف",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "تظهر هذه الصفحة في أسفل منصتكم، تحت التذييل، مع معلومات مُعبأة مسبقاً بواسطة Fluicity Engage كمضيف ومحرر تقني للحل.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "تسمح الإشعارات القانونية بإعلام المستخدمين بهوية مسؤول الموقع، والمضيف، وشروط تحرير المنصة.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "إنها إلزامية لكل موقع مؤسسي أو عام، وتعزز شفافية مسارك.",
      "SPACE_PRIVACY_POLICY": "سياسة الخصوصية",
      "SPACE_PRIVACY_POLICY_LABEL": "الوصف",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "تظهر هذه الصفحة في أسفل منصتك، تحت التذييل، مع معلومات Fluicity Engage.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "سياسة الخصوصية تُعلم المشاركين بمعالجة بياناتهم الشخصية. يمكنك هنا إضافة تفاصيل خاصة بمنظمتك (مثال: مدة الاحتفاظ المحددة، جهة اتصال مسؤول حماية البيانات، الاستخدام الداخلي للبيانات،…).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "يكمل هذا النص <link>سياسة الخصوصية لـ Fluicity Engage</link>، المسؤول الفني عن المنصة، ويضمن الامتثال للائحة العامة لحماية البيانات. يظل إضافة نصك الخاص اختيارياً بناءً على استخدامك للمنصة.",
      "SPACE_TERMS_OF_USE": "شروط الاستخدام",
      "SPACE_TERMS_OF_USE_LABEL": "الوصف",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "أضف محتوى شروط الاستخدام المخصص هنا",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "تحدد شروط الاستخدام قواعد الاستخدام الجيد لمساحتك، وحقوق ومسؤوليات المستخدمين، بالإضافة إلى التزاماتك كمنظم للمبادرة. (مثال: قواعد الإشراف، حقوق المشاركة، إلخ).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "هذا النص يُكمّل <link>شروط الاستخدام لـFluicity Engage</link>، كطرف موثوق وناشر للمنصة. يبقى إضافة نصك الخاص اختياريًا بناءً على استخدامك للمنصة.",
      "TOPICS": "مواضيع",
      "TOPICS_DESCRIPTION": "تسمح الموضوعات بتصنيف المحتوى الخاص بك لمساعدة المستخدمين في العثور على المحتوى وفقًا لاهتماماتهم.",
      "TWITTER_URL_LABEL": "تويتر",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/mypage",
      "UPDATED_SUCCESSFULLY": "تم تحديث الفضاء بنجاح.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "ارسل إشعارًا تلقائيًا عند بدء استشارة ولجميع مراحل المشاركة فيها."
        },
        "TITLE": "إعدادات الإشعارات",
        "WEEKLY": {
          "LABEL": "ارسل ملخصا لأخبار الأسبوع للمشتركين (مقالات جديدة، أحداث جديدة وتذكيرات للمشاركة في استشارة)."
        }
      },
      "WEBSITE_URL_LABEL": "رابط الموقع",
      "WEBSITE_URL_PLACEHOLDER": "https://www.mywebsite.com",
      "YOUR_SPACE": "المساحة الخاصة بك"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "المساحات المرتبطة",
        "SEE_MORE": "مشاهدة المزيد ({count})"
      },
      "FOOTER": {
        "TITLE": "لنبقى على تواصل!"
      },
      "SEE": "نرى",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, zero {لا يوجد أعضاء} one {عضو واحد} two {عضوان} few {{count} أعضاء} other {{count} عضو}}",
        "IDEAS_COUNT": "{count, plural, =0 {لا توجد مشاركات} one {{count} مشاركة} other {{count} مشاركات}}"
      },
      "SPONSOR": "هذه المساحة مرتبطة بـ"
    },
    "NEWS": {
      "EMPTY_STATE": "ستجد هنا المقالات والأحداث التي نشرتها المنظمة.",
      "TITLE": "{count, plural, =0 {لا توجد أخبار} one {خبر واحد} other {{count} أخبار}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "عرض سياسة الخصوصية الخاصة بـ Fluicity Engage"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "نموذج التسجيل",
        "TAB_INVITATIONS": "دعوات"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "إشعارات"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "مظهر",
        "TAB_LANGUAGES": "لغات",
        "TAB_TOPICS": "موضوعات"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "إشعارات قانونية",
        "TAB_PRIVACY_POLICY": "سياسة الخصوصية",
        "TAB_TERMS_OF_USE": "شروط الاستخدام"
      },
      "PAGES": {
        "TAB_ABOUT": "حول",
        "TAB_FOOTER": "ذيل الصفحة",
        "TAB_HOME": "الصفحة الرئيسية",
        "TAB_NAVIGATION": "شريط التنقل"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "عرض شروط استخدام Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "معلومات عامة",
    "PROF_CATEGORY_ID": {
      "LABEL": "الفئة الاجتماعية والمهنية"
    },
    "SECTION": {
      "HEADER": "نموذج التسجيل",
      "SUBTITLE1": "نموذج التسجيل هو أداة تستخدم لجمع بيانات المستخدمين.",
      "SUBTITLE2": "قم بتكوين حقول الجمع وفقًا لاحتياجاتك مع احترام قوانين حماية البيانات العامة."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15-29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": "> 75",
      "LT_15": "<15",
      "TITLE": "سن"
    },
    "AI": {
      "ACTIONS": "تطلعات المستخدمين :",
      "ACTIONS_TOOLTIP": "تم إنشاء هذه الملخصات لتطلعات المستخدمين بواسطة الذكاء الاصطناعي. هدفها هو مساعدتك في تفسير الاقتراحات الأصلية التي قدمها المشاركون. إستنادا إلى على الاقتراحات المجمعة أدناه.",
      "ADD_CLUSTER": "إضافة مجموعة",
      "ADD_SUB_CLUSTER": "إضافة مجموعة فرعية",
      "CLUSTER": {
        "SUMMARY": "وصف الموضوع",
        "SUMMARY_PLACEHOLDER": "وصف الموضوع",
        "TITLE": "اسم الموضوع",
        "TITLE_PLACEHOLDER": "سيتم استخدام اسم المجموعة الفرعية من قبل الذكاء الاصطناعي لتجميع المساهمات."
      },
      "DELETE": "حذف",
      "DESCRIPTION": "الوصف:",
      "EDIT": "تعديل",
      "EDIT_CLUSTER": "تحرير الموضوع",
      "EDIT_SUB_CLUSTER": "تحرير الموضوع الفرعي",
      "EXPLAIN_AI": "لقد استخدمنا الذكاء الاصطناعي لفحص اقتراحات هذه الاستشارة بعناية. هدفنا هو تجميعها في فئات مختلفة بناءً على التشابه ، لتوفير فهم أفضل للاتجاهات والمخاوف الرئيسية والاقتراحات الناشئة. من خلال هذا النهج ، ستتمكن من فهم الأفكار الناشئة والآراء التي تبرز في هذه الاستشارة بشكل أفضل.",
      "GENERATE": "تحليل",
      "IDEAS": "الاقتراحات الأصلية :",
      "IN_FAVOR": "مؤيد",
      "MOVE_IDEA": "نقل",
      "MOVE_IDEA_TITLE": "تغيير الموضوع أو الفرعية",
      "OPPOSED": "معارض",
      "SUB_CLUSTER": {
        "SUMMARY": "وصف الموضوع الفرعي",
        "SUMMARY_PLACEHOLDER": "وصف الموضوع الفرعي",
        "TITLE": "اسم الموضوع الفرعي",
        "TITLE_PLACEHOLDER": "سيتم استخدام اسم الفرع الفرعي للمجموعة الفرعية من قبل الذكاء الاصطناعي لتجميع المساهمات."
      },
      "TOAST": "تحليل الذكاء الاصطناعي قيد التقدم. قد يستغرق ذلك بضع دقائق."
    },
    "CITIES": {
      "TITLE": "مكان الإقامة"
    },
    "CLUSTERS": "مجموعات موضوعية",
    "CLUSTERS_TOOLTIP": "يجمع الذكاء الاصطناعي تطلعات المستخدمين المختلفة في موضوع واحد أو أكثر",
    "CLUSTER_OTHER": "آخر",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "خلال السبعة أيام الماضية"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, =0 {لا توجد مقترحات} one {اقتراح} other {مقترحات}}",
    "DAY": "يوم",
    "DELIVERABILITY": "قابلية التسليم",
    "IDEAS_STATUSES": {
      "TITLE": "حالة الاقتراحات"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, 0 {تعليق} one {تعليق} other {تعليقات}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, 0 {إجابة} one {إجابة} other {إجابات}}",
      "TOTAL_PARTICIPANTS": "{count, plural, 0 {المشاركون} one {مشارك} other {المشاركون}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, 0 {صوت ضد} one {صوت ضد} other {أصوات ضد}}",
      "TOTAL_VOTES_FOR": "{count, plural, 0 {صوت لصالح} one {صوت لصالح} other {أصوات لصالح}}"
    },
    "MONTH": "شهر",
    "NO_DATA": "لا توجد بيانات متاحة في هذا الوقت.",
    "PARTICIPANTS": {
      "TITLE": "عدد المشاركين",
      "TOTAL_PARTICIPANTS": "مشاركون",
      "TOTAL_TARGETED_USERS": "الأعضاء المسجلون"
    },
    "PARTICIPANTS_PROGRESSION": "تطور المشاركين",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "الإجراءات التي قام بها المشاركون",
      "TOTAL_COMMENTS": "علق",
      "TOTAL_IDEAS": "قدم اقتراحا",
      "TOTAL_NO_ACTIONS": "لم يقم بأي إجراء",
      "TOTAL_STUDY_ANSWERS": "أجاب على دراسة",
      "TOTAL_VOTES": "صوت"
    },
    "PARTICIPATION_PROGRESSION": "تطور المشاركة",
    "PERFORMANCE": "الأداء",
    "PROF_CATEGORIES": {
      "TITLE": "الفئة الاجتماعية المهنية"
    },
    "REFERRERS": "مصادر الحركة",
    "SECTIONS": {
      "ACTIVITY": "نشاط",
      "ENGAGEMENT": "التزام",
      "PARTICIPANTS_PROFILE": "الملف الشخصي للمشاركين"
    },
    "SEX": {
      "TITLE": "الجنس",
      "TOTAL_": "غير محدد",
      "TOTAL_FEMALE": "أنثى",
      "TOTAL_MALE": "ذكر",
      "TOTAL_UNSPECIFIED": "غير محدد"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "هدف التسجيلات",
      "TOTAL_TARGETED_USERS": "استهداف",
      "TOTAL_USERS": "الأعضاء المسجلون"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "تطور التسجيلات"
    },
    "TAB_AI": "الذكاء الاصطناعي (تجريبي)",
    "TAB_ATTENDEES": "الحاضرين",
    "TAB_CONTENTS": "المحتويات",
    "TAB_DETAILS": "التفاصيل",
    "TAB_EMAILS": "البريد الإلكتروني مع الكاتب",
    "TAB_LIST": "قائمة",
    "TAB_PARTICIPATION": "مشاركة",
    "TAB_PRIVATE_NOTES": "ملاحظات داخلية",
    "TAB_PROPOSALS": "الاقتراحات",
    "TAB_RESPONSES": "الردود",
    "TAB_RESULTS": "النتائج",
    "TAB_SETTINGS": "الإعدادات",
    "TAB_STATS": "إحصائيات",
    "TAB_VOTES": "التصويت",
    "TARGETED_POPULATION": "التركيبة السكانية (مصدر رسمي)",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "عنوان",
      "COL_TOTAL": "مشاركون",
      "SUBTITLE": "مجموع المقترحات والتعليقات والأصوات أو الردود على الدراسة",
      "TITLE": "أعلى الاستشارات"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "عنوان",
      "COL_TOTAL": "زوار",
      "COL_TYPE": "اكتب",
      "TITLE": "أكثر المحتويات زيارة"
    },
    "TOTAL_ANSWERS": "{answersCount} من {totalCount} {totalCount, plural, 0 {مجيب} one {مجيب} other {مجيبين}}",
    "TOTAL_BOUNCED": "مرتدة",
    "TOTAL_CLICKED": "تم النقر",
    "TOTAL_COMMENTS": "تعليقات",
    "TOTAL_COMMUNICATIONS": "أخبار",
    "TOTAL_CONSULTATIONS": "استشارات",
    "TOTAL_DELIVERED": "تم التوصيل",
    "TOTAL_IDEAS": "اقتراحات",
    "TOTAL_OFFLINE_VOTES": "تصويت غير متصل",
    "TOTAL_ONLINE_VOTES": "تصويت عبر الإنترنت",
    "TOTAL_OPENED": "تم الفتح",
    "TOTAL_PARTICIPANTS": "مشاركون",
    "TOTAL_REJECTED": "مرفوضة",
    "TOTAL_RESPONDENTS": "المستجيبون",
    "TOTAL_SENT": "مرسلة",
    "TOTAL_STUDY_ANSWERS": "الردود على الدراسة",
    "TOTAL_USERS": "الأعضاء المسجلون",
    "TOTAL_VOTERS": "الناخبون",
    "TOTAL_VOTES": "الأصوات",
    "UNIQUE_VISITS": "زيارات فريدة",
    "USERS_WHO_ANSWERED": "{count, plural, zero {{count} مجيب} one {مجيب واحد} two {مجيبان} other {{count} مجيب}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "الإجراءات التي يقوم بها الأعضاء",
      "TOTAL_COMMENTS": "علق",
      "TOTAL_IDEAS": "قدم اقتراحا",
      "TOTAL_NO_ACTIONS": "لم يقوم بأي إجراء",
      "TOTAL_STUDY_ANSWERS": "أجاب على دراسة",
      "TOTAL_VOTES": "صوت"
    },
    "WEEK": "أسبوع",
    "WORD_CLOUD": "سحابة كلمات"
  },
  "TEXT_FIELD": {
    "LENGTH": "{length} / {maxLength}",
    "LENGTH_ERROR": "{length} / {maxLength} - لقد تجاوزت count الأحرف المسموح به.",
    "LENGTH_ERROR_TEXT": "لقد تجاوزت count الأحرف المسموح به."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "دائري",
    "BUTTON_GROUP": "قم بتغيير وضع العرض",
    "BUTTON_LIST": "قائمة",
    "BUTTON_MAP": "خريطة"
  },
  "TOKENS": "{count, plural, =0 {رمز} one {{count} رمز} other {{count} رموز}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "إضافة موضوع",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "يتم حاليًا تصنيف محتوى أو أكثر من منصتك ضمن هذا الموضوع.",
      "DESCRIPTION_2": "عند تعديلها أو حذفها، ستغير تصنيف هذه المحتويات.",
      "TITLE": "هل أنت متأكد؟"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "انظر النص الأصلي",
    "SUCCESS": "تمت الترجمة بنجاح.",
    "TRANSLATE": "ترجم",
    "TRANSLATING": "الترجمة جارية"
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "يسمح لك الكتل بتخصيص صفحتك من خلال تسليط الضوء على معلومات بتنسيق النص والصورة والفيديو.",
        "SECTION_HEADER": "كتل"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "تُمكّنك الكتل من تخصيص صفحتك عن طريق تسليط الضوء على المعلومات بتنسيق النص، الصورة، الفيديو، وأيضًا المحتويات المميزة.",
        "SECTION_HEADER": "كتل"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "الإبلاغ عن مشكلة بشكل خاص",
          "TITLE": "شذوذ"
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "نص، صورة وفيديو",
          "TITLE": "مخصص"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "الاتصال الخاص عبر المنصة",
          "TITLE": "البريد الوارد"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "استشارة بارزة، جارية وقادمة",
          "TITLE": "استشارة"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "مقالة وفعالية",
          "TITLE": "الأخبار"
        },
        "FOLDERS": {
          "DESCRIPTION": "ملف ومجلد فرعي",
          "TITLE": "ملف"
        },
        "KPIS": {
          "DESCRIPTION": "عدد المسجلين، المساهمات والاستشارات",
          "TITLE": "بعض الأرقام"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "مشاركة المستخدمين",
          "TITLE": "مساهمة"
        },
        "SPACE_INFO": {
          "TITLE": "الشريط العلوي"
        }
      },
      "LAYER_ADD_MEDIA": "أضف الوسائط",
      "LAYER_ADD_PICTURE": "صورة",
      "LAYER_ADD_VIDEO": "فيديو",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "النصوص مركزة بالنسبة للوسائط",
          "LABEL": "مركز"
        },
        "LEFT": {
          "DESCRIPTION": "النصوص على يسار الوسائط.",
          "LABEL": "على اليسار"
        },
        "RIGHT": {
          "DESCRIPTION": "النصوص على يمين الوسائط",
          "LABEL": "على اليمين"
        },
        "TITLE": "عرض"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "جميع الأخبار",
        "ARTICLE": "مقالة",
        "EVENT": "حدث",
        "LABEL": "نوع",
        "PINNED": "في الصدارة"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "جميع الاستشارات",
        "ENDED": "الاستشارات المنتهية",
        "LABEL": "نوع",
        "ONGOING": "استشارات جارية",
        "PINNED": "الأخبار الرئيسية"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "الاستشارات المُطلقة",
        "CONTRIBUTIONS_COUNT": "المساهمات المحققة",
        "PARTICIPATIONS_COUNT": "المشاركات (المساهمات، الردود على الاستطلاعات، الأصوات والتعليقات المقدمة)",
        "TITLE": "عرض العدد:",
        "USERS_AND_PARTICIPATIONS_COUNT": "المسجلون والمشاركات",
        "USERS_COUNT": "المسجلون"
      },
      "LAYER_CTA_LABEL": "تسمية الزر",
      "LAYER_CTA_LABEL_PLACEHOLDER": "ما تريد عرضه على الزر",
      "LAYER_CTA_URL": "رابط الزر",
      "LAYER_CTA_URL_PLACEHOLDER": "رابط إلى صفحة أو وثيقة",
      "LAYER_DESCRIPTION_LABEL": "وصف",
      "LAYER_DESCRIPTION_PLACEHOLDER": "حدد نص الكتلة. اجعلها قصيرة وفعالة.",
      "LAYER_FILTERING_TYPE": {
        "ALL": "جميع الملفات",
        "CHILDREN": "محتويات الملف",
        "CUSTOM": "مخصص",
        "SELECT_FOLDER": "اختر مجلدًا",
        "SELECT_FOLDERS": "اختر المجلدات",
        "TYPE_LABEL": "نوع التصفية"
      },
      "LAYER_PICTURE_LABEL": "صورة",
      "LAYER_TITLE_LABEL": "عنوان",
      "LAYER_TITLE_PLACEHOLDER": "حدد عنوان الكتلة",
      "SELECTION_DIALOG": {
        "TITLE": "إنشاء كتلة"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "اتصل بالعضو",
      "INVITE": "دعوة",
      "UNREGISTER": "غير مسجل",
      "UPDATE_ROLE": "تحديث الدور"
    },
    "EXPORT": "تصدير بيانات الأعضاء",
    "EXPORT_SUCCESS_TOAST": "التصدير قيد التقدم. ستتلقى بريدًا إلكترونيًا عندما يكون جاهزًا.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "قائمة رسائل البريد الإلكتروني المفصولة بغيبوبة",
        "EMAILS_PLACEHOLDER": "مثال: user1@organisation.com ، user2@association.org",
        "MESSAGE_LABEL": "رسالة دعوة",
        "MESSAGE_PLACEHOLDER": "أدخل رسالة قصيرة ولكنها ملهمة ستجعل الأعضاء يرغبون في الانضمام إلى مساحتك والمساهمة.",
        "SUCCESS_TOAST": "تمت دعوة الأعضاء بنجاح.",
        "TITLE": "ادعُ الأعضاء",
        "WARNING": "تأكد من حصولك على موافقة الأعضاء قبل إرسال دعوة إليهم."
      },
      "DELETE_FORM": {
        "CONTENT": "أنت على وشك إلغاء الدعوة المرسلة إلى <b>{email}</b> . هل تريد حقًا المتابعة؟",
        "DELETE": "حذف",
        "TITLE": "حذف الدعوة"
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "أنت على وشك إلغاء تسجيل العضو &quot; <strong>{userName}</strong> &quot; من مساحة المشاركة الخاصة بك.",
      "DESCRIPTION_2": "إذا كانت المساحة خاصة ، فلن يتمكن العضو من الوصول إليها مرة أخرى. سيكون عليك إعادة دعوة العضو لإلغاء هذا الإجراء.",
      "DESCRIPTION_3": "إذا كانت المساحة عامة ، فلن يتمكن العضو من المشاركة. سيتعين عليه أو عليها التسجيل مرة أخرى لإلغاء هذا الإجراء.",
      "DESCRIPTION_4": "هل تريد المتابعة؟",
      "TITLE": "عضو غير مسجل"
    }
  },
  "USER_AVATAR": "الصورة الرمزية للعضو",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "لقد وصلت إلى الحد الأقصى لعدد التصويتات",
    "MAX_VOTES_WARNING": "{count, plural, =0 {لا يمكنك التصويت على المزيد من المقترحات} one {<strong>يمكنك التصويت على # اقتراح إضافي</strong>.} few {<strong>يمكنك التصويت على # مقترحات إضافية</strong>.} other {<strong>يمكنك التصويت على # مقترحا إضافية</strong>.}}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {لقد صوّتت على عدد كافٍ من المقترحات} one {يتطلب <strong>صوت إضافي واحد</strong> لتأكيد مشاركتك.} few {يتطلب <strong># أصوات إضافية</strong> لتأكيد مشاركتك.} other {يتطلب <strong># صوتا إضافيا</strong> لتأكيد مشاركتك.}}",
    "VALID_PARTICIPATION": "تم تأكيد مشاركتك."
  },
  "VIEW_ALL": "عرض الكل",
  "VIRUS_SCAN": {
    "CLEAN": "نجح فحص الفيروسات",
    "INFECTED": "ملف مصاب",
    "INFECTED_ATTACHMENTS_ERROR": "يبدو أن المستند مصاب. يرجى حذفه قبل الحفظ.",
    "NO_SCAN": "فحص الفيروسات قيد التقدم ..."
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "تاريخ الميلاد: {birthdate}",
        "DELETE_VOTE": "حذف التصويت",
        "EMPTY": "غير محدد",
        "IMPORTED_AT": "وارد في {date}",
        "KEEP_BOTH": "الاحتفاظ بكليهما",
        "PARTICIPATED_AT": "المشاركة في {date}"
      },
      "DESCRIPTION": "تأخذ تحليل التكرارات في الاعتبار الاسم واللقب للمستخدمين. لمعالجة التكرار، اختر التصويت الذي ترغب في حذفه من بين المشاركتين.",
      "FOUND_DUPLICATES": "لديك <b>{count, plural, one {{count} ناخب محدد كمكرر} other {{count} ناخب محدد كمكرر}}</b>. آخر تحديث <b>{timeAgo}</b>",
      "LOADING": "التحقق قيد التقدم...",
      "NO_DUPLICATES": "لا يوجد تكرار محدد. تم التحديث آخر مرة قبل <b>{timeAgo}</b>",
      "PLACEHOLDER": "ستجد هنا الناخبين المحددين كمكررين.",
      "REFRESH": "تحديث",
      "START_CHECK": "بدء التحقق",
      "TITLE": "إدارة التكرار"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "أدخل عنوان URL"
    },
    "PLACEHOLDER": "ابدأ الكتابة..."
  }
}